import React, { Component, LegacyRef, RefObject, createRef } from "react";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";
import { callApi, API_ENDPOINT } from "../../utils/api";
import { CircularProgress } from "@material-ui/core";
import ReactFileReader from "react-file-reader";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import Rotate90DegreesCcwIcon from "@material-ui/icons/Rotate90DegreesCcw";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import { isEmpty } from "lodash";
import { saveAs } from "file-saver";

import GeneralVerification from "./generalVerification";
import Hsdpatta from "./hsdpatta";
import SurveyNoVerification from "./surveyNoVerification";
import Deed from "./deed";
import LegalHerisVerification from "./legalHerisVerify";
import ECVerification from "./ecVerify"; 
import MissingLOD from "./missingLOD";
import Verification from "./verification";
import CourtDocVerify from "./courtDocVerify";
import VerificationEOD from "../work-file/verificationEod";

import DataModel from "./sopDataModel";
import PdfHighlighter from "../PDF-Highlighter";
import moment from "moment";
import { notifyToUser } from "../../utils/firebase";
import { pushnotificationApi } from "../../utils/pushNotify";
import Flowchart from "./flowchart";
import { ADMIN_ROLE, FRONTOFFICE_ROLE, MANAGER_ROLE } from "../../utils/role";
import CountdownTimer from "../../components/file/CountdownTimer";
import { toast } from "react-toastify";
import { PiDotsThreeCircleVerticalFill } from "react-icons/pi";
import "./ThreeDotsMenu.css";
import DashUploadDocument from "../file/DashUploadDocument";
import { cloneDeep } from "lodash";
import Nathampatta from "./Nathampatta";
import QueryAdd from "../file/QueryAdd";
import { compressPdf } from "../PdfCompress/PdfCompressor";
import Flow from "./Flow";
import Propertytax from "./Propertytax";
import EBreceipt from "./EBreceipt";
import OriginalDocVerify from "./OriginalDocVerify";
declare var $: any;

interface AllProps {
  history: any;
  match: any;
  location: any;
  verifiedfile: string;
}

interface QueryItem {
  query: string;
  location: string;
  review: string;
  other_review: string;
  created_date: string;
  is_checked: boolean;
}

interface ReQueryItem {
  query: string;
  location: string;
  review: string;
  query_id: string;
  other_review: string;
  created_date: string;
}
export class VerificationList extends Component<AllProps> {
  saveFlowDeed: any;
  documentFormat = {
    base: "",
    base_url: "",
    docNoYear: "",
    particular: "xerox",
    type: "",
    isValid: true,
    doc_type: "",
  };
  state = {
    showTitle: false,
    isComplete: true,
    base: "",
    data: DataModel,
    report: "",
    numPages: 0,
    isapproved: 0,
    action: "",
    reason: "",
    uploadFile: {
      base64: "",
      fileList: [{ name: "" }],
      autoQuestionsList: [],
      manualQuestionsList: [],
      currentAutoColumnNumber: 1,
      currentManualColumnNumber: 1,
      activeTab: "ManualView",
    },
    verification: {
      // isComplete: false,
      highlight: false,
      dataEntry: false,
      flowChart: false,
      hintFile: false,
      errorIdentified: false,
      noOflod: "",
      errorSection: [],
      otherSection: "",
      errorTypes: [],
      errorDetails: "",
      totalTime: 0,
      userId: "",
      fileId: "",
    },
    type: "",
    allDocuments: [],
    selectedDoc: "",
    isHightlightsLoaded: false,
    documentWidth: 50,
    documentHeight: 600,
    pinchEnabled: false,
    enableTouchPadPinch: false,
    velocityEqualToMove: false,
    enableVelocity: false,
    rotation: 0,
    disabled: true,
    docToPreview: false,
    highlights: [],
    deeds: [],
    updateDownloadData: {
      reasonForDownload: [],
      updatedDetails: [],
    },
    lastUploadedDocument: {
      pdf: null,
      docx: null,
    },
    shellTemplate: null,
    lastScrutinyDocument: null,
    blockdownload: "",
    hints: [],
    selectedCurrentView: null,
    isGraphModalShown: false,
    isManualDataAvailable: true,
    isManualClicked: false,
    isQuestionsExpanded: false,
    autoQuestionsList: [],
    manualQuestionsList: [],
    currentAutoColumnNumber: 1,
    activeTab: "ManualView",
    currentManualColumnNumber: 1,
    isFlowChartExpanded: true,
    activeMainTab: "",
    flowGraphData: null,
    isflowGraphDataupdated: false,
    deedData: [],
    currentQuestionsList: [],
    initialTimeInMinutes: 0,
    updatedRemainingTime: 0,
    verificationEOD: false,
    isLoading: false,
    isOnLoading: false,
    holdType: "",
    holdreason: "",
    holdVal: false,
    isOpen: false,
    categoriesList: [],
    uploadbtn: false,
    isbtnload: false,
    isNewFile: false,
    verificationbase: [],
    doc_count: 0,
    returnPOreason: "",
    returnPOValidation: false,
    overviewReport: "",
    timer: 0,
    serverLocalFileName: "",
    filestatus: "",
    file_grade: "",
    fileOpinionType: "",
    dverify_officer: "",
    verify_officer: "",
    newQueryList: [] as QueryItem[],
    reQueryList: [] as ReQueryItem[],
    reasons: [],
    office_users: [],
    remote_users: [],
    remote_cc_users: [],
    queryBase: [],
    queryQues: [],
    oldQueryQues: [],
    quesSubmitted: false,
    queryLoading: false,
    previewDoc: "",
    isGlobalPdfCompress: "",
    globalPdfCompressQuality: "",
    isFrontOfficePdfCompressShow: "",
    isSroEcPdfCompressQuality: "",
    isOnlineEcPdfCompressQuality: "",
    formDataLoading: false,
    fileNotCompleteMsg: { __html: "" } as any,
  };
  intervalId: NodeJS.Timeout | null = null;
  menuRef: RefObject<HTMLDivElement> = createRef();
  document = {
    base: "",
    numPages: 0,
    pageNumber: 1,
  };

  remarksRef: LegacyRef<HTMLTextAreaElement> = React.createRef();
  autoGraph: any;
  manualGraph: any;
  manualPaper: any;

  countdownTimerRef: CountdownTimer | null = null;
  timeoutId: any = null;
  componentDidMount() {

    this.setState({ data: DataModel });
    this.fetchPdfSettings();
    // this.getScrutinizedDocs();
    this.getFileOverview();
    this.getFormData();
    this.getDeeds();
    // this.getRevenueDocs();
    this.getAllDocuments();
    this.getUpdateReasonData();
    this.getScrutinyReport();
    this.liveinsert();
    this.blockdownload();
    this.getHints();
    this.getqueData();
    this.getVerifiyTargetTime();
    this.getFiles();
    setInterval(() => {
      this.incrementTimer();
    }, 1000);
    setTimeout(() => {
      this.scrutinyReport();
    }, 2000);
    this.listreason();
    this.getUsers();
    localStorage.setItem("dashboard_status", "2");
    localStorage.setItem("file_Id", this.props.match.params.id);
    // localStorage.setItem("currentfileId", this.props.match.params.id);
    localStorage.setItem("verifyfileId", this.props.match.params.id);
    // $("#balance-time").modal("show");

    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {

    if (this.countdownTimerRef) {
      this.countdownTimerRef.clearInterval();
    }
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  fetchPdfSettings = () => {
    callApi("POST", "pdf_category.php")
      .then((res) => res.data)
      .then((response: any) => {
        if (response.result && response.data) {
          const isGlobalPdfCompress =
            response.data["Pdf document"]?.find(
              (item: any) =>
                item.name == "Pdf Compression While Uploading Document"
            )?.status == "1";
          const globalPdfCompressQuality = response.data["Pdf document"]?.find(
            (item: any) =>
              item.name == "Pdf Compression While Uploading Document"
          )?.quality;
          const isFrontOfficePdfCompressShow =
            response.data["Pdf document"]?.find(
              (item: any) => item.name == "In Query Upload Show/Hide"
            )?.status == "1";
          const isSroEcPdfCompressQuality = response.data["Pdf Category"]?.find(
            (item: any) => item.name == "SRO Encumbrance Certificate"
          )?.quality;
          const isOnlineEcPdfCompressQuality = response.data[
            "Pdf Category"
          ]?.find(
            (item: any) => item.name == "Online Encumbrance Certificate"
          )?.quality;
          this.setState({
            isGlobalPdfCompress,
            isFrontOfficePdfCompressShow,
            globalPdfCompressQuality,
            isSroEcPdfCompressQuality,
            isOnlineEcPdfCompressQuality,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        ToastsStore.error("Failed to load PDF settings");
      });
  };

  getUsers = () => {
    const remote_users: any = [];
    callApi("POST", "office_details.php", {
      id: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => {
        response.data.map((user) => {
          remote_users.push({ email: user.email, name: user.name });
        });
        this.setState({
          office_users: response.data,
          remote_users,
          remote_cc_users: remote_users,
        });
      });
  };

  listreason = () => {
    this.setState({ isFileRefresh: false });
    callApi("GET", "query_reason_get.php")
      .then((res) => res.data)
      .then((response) => {
        const files = response.data;
        this.setState({ reasons: files });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  toggleMenu = () => {
    this.setState((prevState: any) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  handleClickOutside = (event) => {
    if (this.menuRef.current && !this.menuRef.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };
  toAddonFeature = () => {
    localStorage.setItem("verification_to_addon", JSON.stringify(true));
    this.props.history.push("/work-file/6/" + this.props.match.params.id);
  };
  gotoFlowchart = () => {
    this.props.history.push("/sale-deed/" + this.props.match.params.id);
  };
  gotoWorkfile = () => {
    // this.props.history.push("/work-file/7/" + id);
    localStorage.setItem("verification_to_addon", JSON.stringify(true));

    this.props.history.push("/work-file/7/" + this.props.match.params.id);
  };
  getVerifiyTargetTime = () => {
    const verification_officer: any = localStorage.getItem(
      "verification_office_id"
    );
    const userid1: any = localStorage.getItem("user1");
    const userid = JSON.parse(userid1);
    callApi("POST", "get_verify_target_time.php", {
      file_id: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.statusCode == 200) {
          if (verification_officer == userid) {
            if (response.data[0].target_min == 0) {
              $("#balance-time").modal("show");
            } else {
              let initialTimeInMinutes: any = localStorage.getItem(
                "updatedRemainingTime"
              );
              if (initialTimeInMinutes > 0) {
                this.setState(
                  (prevState: any) => ({
                    initialTimeInMinutes: initialTimeInMinutes,
                  }),
                  () => { }
                );
              } else if (response.data) {
                this.setState(
                  {
                    initialTimeInMinutes: response.data[0].target_min,
                  },
                  () => {
                    console.log(
                      "response.data[0].target_min",
                      response.data[0].target_min
                    );
                  }
                );
              } else {
                this.setState(
                  {
                    initialTimeInMinutes: 0,
                  },
                  () => { }
                );
              }
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getqueData = () => {
    callApi("POST", "get_flowchart.php", {
      fileId: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data) {
          let manualQuestionList = response.data.manualQuestion;
          if (manualQuestionList) {
            this.setState({
              manualQuestionsList: JSON.parse(manualQuestionList),
            });
          }
          console.log("getqueData------------->", manualQuestionList);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getHints = () => {
    callApi("POST", "hint_get.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((result) => {
        this.setState({ hints: result.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  blockdownload = () => {
    callApi("POST", "block_download_status.php", {
      file_idfk: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => {
        this.setState({
          blockdownload: response["responseJson"].data[0].block_download_status,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getUpdateReasonData = () => {
    const reasonData: any = this.state.updateDownloadData;
    callApi("POST", "dashboard_log.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((result) => {
        let { lastUploadedDocument } = this.state;
        reasonData.reasonForDownload = result.data.reasonForDownload;
        reasonData.updatedDetails = result.data.updatedDetails;
        if (reasonData.updatedDetails && reasonData.updatedDetails.length > 0) {
          lastUploadedDocument = reasonData.updatedDetails[0].url[0];
        }
        this.setState({ updateDownloadData: reasonData, lastUploadedDocument });
      })
      .catch((err) => {
        console.log("Errororor", err);
        // ToastsStore.error("Failed to get ");
      });
  };

  getAllDocuments = () => {
    callApi("POST", "all_doc_no_list.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        const documentList: any = response.data;
        if (documentList.length > 0) {
          const documentValue = response.data[0]
            ? response.data[0]["base_id"]
            : null;
          if (documentValue) {
            this.setState({ selectedDoc: documentValue }, () => {
              this.viewDocument(documentValue);
            });
          }
        }
        this.setState({ allDocuments: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  viewDocument = (id) => {
    this.setState({ isHightlightsLoaded: false });
    callApi("POST", "getbaseby_id.php", { id })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          this.getScrutinizedDocs(id);
          const document = this.document;
          document.base = response.data[0].base[0].base;
          this.setState(
            {
              ...document,
              selectedDoc: id,
              base: response.data[0].base[0].base,
            },
            () => this.setState({ isHightlightsLoaded: true })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getTemplates = (deed) => {
    callApi("POST", "template_list_bydeed.php", { deed })
      .then((res) => res.data)
      .then((response) => {
        this.setState({ templates: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // function name(params:type) {

  // }
  getDynamicFields = (id) => {
    callApi("POST", "input_master_get.php", { id })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          response.data.map((dynamic) => {
            if (dynamic.type === "select") {
              const patchDynamicField: any = [];
              const fieldSelected = !isEmpty(this.state[dynamic.name])
                ? this.state[dynamic.name].split(",")
                : [];
              fieldSelected.map((val) => {
                const selField: any = dynamic.optionList.find(
                  (all: any) => all.name === val
                );
                patchDynamicField.push(selField);
              });
              this.setState({
                [dynamic.name]: patchDynamicField,
                modifySelectToCommas: [dynamic.name],
              });
            }
          });
          this.setState({ dynamicFields: response.data });
        } else {
          this.setState({ dynamicFields: [] });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  manageStaticFields = (id) => {
    callApi("POST", "dynamic_form.php", { id })
      .then((res) => res.data)
      .then((response) => {
        this.setState({ staticFilesToHide: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getScrutinizedDocs = (id) => {
    callApi("POST", "doc_scrutinize_get.php", {
      id: id,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          const state = response.data[0].scrutinize[0];
          // state.base = response.data[0].base[0].base;
          if (state.nature_doc) {
            this.getTemplates(state.nature_doc);
          }
          state.main_favour = response.data[0].favour;
          state.main_executant = response.data[0].executant;
          state.highlights = response.data[0].highlights || [];
          state.sheetCount = response.data[0].sheetCount || "";
          if (!state.main_favour || !state.main_favour.length) {
            state.main_favour = [];
            state.main_favour.push({ favour: "" });
          }
          if (!state.main_executant || !state.main_executant.length) {
            state.main_executant = [];
            state.main_executant.push({ executant: "" });
          }
          if (state.template) {
            this.getDynamicFields(state.template);
            this.manageStaticFields(state.template);
          }
          const deedSelected = state.deed ? state.deed.split(",") : [];
          state.deed = [];
          deedSelected.forEach((deed) => {
            const selDeed: any = this.state.deeds.find(
              (all: any) => all.id === deed
            );
            state.deed.push(selDeed);
          });
          this.setState({ ...state, isHightlightsLoaded: true });
        }
        this.getDeeds();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getDeeds = () => {
    callApi("POST", "deed_master_get.php", { category: this.state.type })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          const deeds = response.data;
          this.setState({ deeds });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getRevenueDocs = () => {
    callApi("POST", "getbaseby_id.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          let document = this.document;
          document.base = response.data[0].base[0].base;
          var totalDocs = document.base;
          this.setState({
            ...document,
            type: response.data[0].base[0].type,
            selectedDoc: "",
            base: totalDocs,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onHighlightsChange = (highlights) => {
    this.setState({ highlights });
  };

  rotate = () => {
    let newRotation = this.state.rotation + 90;
    if (newRotation >= 360) {
      newRotation = -360;
    }
    this.setState({ rotation: newRotation });
  };

  getFileOverview = () => {
    const props: any = this.props;
    callApi("POST", "final_report_get.php", {
      file_idfk: props.match.params.id,
      check: true,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response && response.data && response.data.length) {
          if (response.data[0].rep_id) {
            // const state = response.data[0];
            // this.setState({ ...state });
          } else {
            this.getScrutinyReport();
          }
          this.setState({ isapproved: response.data[0].isapproved });
        }
      });
  };

  getScrutinyReport = () => {
    const props: any = this.props;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "template/tests/scrutiny_report.php", {
      file_idfk: props.match.params.id,
      check: true,
      userId,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response) {
          const lastScrutinyDocument =
            API_ENDPOINT +
            "template/tests/output/" +
            response.file_name +
            ".pdf";
          this.setState({ report: "" });
          this.setState({ report: response.data, lastScrutinyDocument });
        }
      });
  };

  getFiles = () => {
    callApi("POST", "search.php", {
      file_name: this.props.match.params.id,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response["data"] && response["data"][0]) {
          const filestatus = response["data"][0].file_status;
          const file_grade = response["data"][0].file_grade;
          const fileOpinionType = response["data"][0].opinion_type;
          const verify_officer = response["data"][0].verified_by;
          const dverify_officer = response["data"][0].dverified_by;
          this.setState({
            filestatus,
            file_grade,
            fileOpinionType,
            verify_officer,
            dverify_officer,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  incrementTimer = () => {
    this.setState((prevState: any) => ({
      timer: prevState.timer + 1,
    }));
  };

  scrutinyReport = () => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "template/tests/scrutiny_report_zmq.php", {
      file_idfk: this.props.match.params.id,
      check: false,
      userId,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response && response.data && response.status == 130) {
          console.log("response.data------>>>>>", response);
          localStorage.setItem("serverLocalFileName", response.local_file_name);
          this.setState({ serverLocalFileName: response.local_file_name });
          this.finalReport(response);
        } else {
          this.setState({ enableRefresh: false });
          this.scrutinyReport();
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ enableRefresh: false });
        this.scrutinyReport();
      });
  };

  finalReport = (zmqresponse) => {
    const makeApiCall = () => {
      this.setState({ isOnLoading: true });
      const url = zmqresponse.doc_path;

      fetch(url)
        .then((response) => {
          console.log(`Status Code: ${response.status}`);
          if (response.ok && response.status == 200) {
            console.log("URL is reachable.", response);
            // If status is 200, clear the timeout
            clearTimeout(this.timeoutId);
            localStorage.setItem("verify-overviewDocument", zmqresponse.data);
            var currentFile = zmqresponse.file_name.split("-");
            localStorage.setItem("currentFile", currentFile[1]);
            this.stopTimer();
            this.setState({
              overviewReport: zmqresponse.data,
              enableRefresh: true,
              isOnLoading: false,
            });
            $("#root").unbind();
          } else {
            console.log("URL is not reachable.", response);
            // If status is 404, set the timeout for the next call
            this.timeoutId = setTimeout(makeApiCall, 10000);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };

    // Initial call to the function
    makeApiCall();
  };

  stopTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  // getFormData = () => {
  //   const user: any = localStorage.getItem("user");
  //   const userId = user ? JSON.parse(user)["userId"] : "";
  //   const fileId = this.props.match.params.id;
  //   callApi("POST", "get_verification_checklist.php", {
  //     fileNo: fileId,
  //     userId,
  //   })
  //     .then((res) => res.data)
  //     .then((response) => {
  //       if (response?.responseJson?.data?.currentJson) {
  //         this.setState({
  //           data: JSON.parse(response?.responseJson?.data?.currentJson),

  //           verificationEOD:
  //             response?.responseJson?.data?.eod_submit == true ? true : false,
  //         });
  //       } else {
  //         this.setState({ data: DataModel });
  //         this.getVerificationListData();
  //       }
  //     })
  //     .catch((err) => {
  //       this.setState({ data: DataModel });
  //       this.getVerificationListData();
  //     });
  // };

  // getVerificationListData = () => {
  //   const fileId = this.props.match.params.id;
  //   callApi("POST", "get_verification.php", {
  //     fileNo: fileId,
  //   })
  //     .then((res) => res.data)
  //     .then((response) => {
  //       if (response && response.data) {
  //         let modifiedData = { ...this.state.data };
  //         Object.entries(response.data).forEach((data: any) => {
  //           if (data[0] && data[1]) {
  //             modifiedData = {
  //               ...modifiedData,
  //               [data[0]]: {
  //                 ...modifiedData[data[0]],
  //                 ...data[1],
  //               },
  //             };
  //           }
  //         });
  //         this.setState({
  //           data: modifiedData,
  //           verificationEOD: response?.eod_submit,
  //         });
  //       } else {
  //         this.setState({ data: DataModel });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  // Helper function to check if value has actual data
  hasValue = (value: any): boolean => {
    return value !== undefined && value !== null && value !== '';
  };

  // Helper function to conditionally add a field only if it has a value
  addIfHasValue = (obj: any, key: string, value: any) => {
    if (this.hasValue(value)) {
      obj[key] = value;
    }
  };
    
  // 1. Map propertyDetails with all fields from API - DO NOT MAP "verified" fields
  mapPropertyDetails = (propertyDetails: any = {}) => {
    const mapped: any = {};
    
    // Only add fields that have values
    if (this.hasValue(propertyDetails.ownerAadharName)) {
      mapped.ownerAadharName = { value: propertyDetails.ownerAadharName };
    }
    
    if (this.hasValue(propertyDetails.borrowerAadharName)) {
      mapped.borrowerAadharName = { value: propertyDetails.borrowerAadharName };
    }
    
    if (this.hasValue(propertyDetails.coBorrowerAadharName)) {
      mapped.coBorrowerAadharName = { value: propertyDetails.coBorrowerAadharName };
    }
    
    // FIX: Handle addressofProperty specially - it's an object with multiple address lines
    if (propertyDetails.addressofProperty) {
      const addressObj = propertyDetails.addressofProperty;
      
      // Check if it's an object with numeric keys
      if (addressObj && typeof addressObj === 'object') {
        // Create a new object for the address
        const addressData: any = {};
        
        // Copy all numeric properties as-is (for multiple address lines)
        Object.keys(addressObj).forEach(key => {
          // Check if key is numeric or string
          if (!isNaN(Number(key)) || key === 'verified' || key === 'value') {
            addressData[key] = addressObj[key];
          }
        });
        
        // Make sure we have at least one address line
        // If no verified property, add it as false by default
        if (addressData.verified === undefined) {
          addressData.verified = false;
        }
        
        mapped.addressofProperty = addressData;
      } else {
        // If it's a simple string, wrap it with verified false
        mapped.addressofProperty = { 
          "1": addressObj, 
          verified: false 
        };
      }
    }
    
    if (this.hasValue(propertyDetails.AppIdverfy)) {
      mapped.AppIdverfy = { value: propertyDetails.AppIdverfy };
    }
    
    // ownerShip has a default value
    if (this.hasValue(propertyDetails.ownerShip)) {
      mapped.ownerShip = { value: propertyDetails.ownerShip };
    } else {
      mapped.ownerShip = { value: "Individual" };
    }

    return mapped;
  };

  // 2. Map missingLOD correctly - NO BOOLEAN FIELDS
  mapMissingLOD = (missingLOD: any = {}) => {
    const result: any = {
      missingLOD: {
        sheets: []
      }
    };

    if (missingLOD && missingLOD.sheets && Array.isArray(missingLOD.sheets)) {
      result.missingLOD.sheets = missingLOD.sheets.map((item: any) => {
        const mappedItem: any = {};
        
        this.addIfHasValue(mappedItem, 'fileNo', item.fileNo);
        this.addIfHasValue(mappedItem, 'fileName', item.fileName);
        this.addIfHasValue(mappedItem, 'totalSheets', item.totalSheets);
        this.addIfHasValue(mappedItem, 'availableSheets', item.availableSheets);
        this.addIfHasValue(mappedItem, 'missingSheets', item.missingSheets);
        this.addIfHasValue(mappedItem, 'missingSheetsNumbers', item.missingSheetsNumbers);
        // isCertificateAttached: REMOVED - comes from process_checklist only
        
        return mappedItem;
      });
    }

    return result;
  };

  // 3. Map surveyNoVerification with all fields - NO BOOLEAN FIELDS
  mapSurveyVerification = (survey: any = {}) => {  
    const result: any = {
      surveyNoVerification: {
        titleDeed: [],
        currentPatta: [],
        register: [],
      }
    };

    // Only add top-level fields that have values
    this.addIfHasValue(result.surveyNoVerification, 'totalTitleDeed', survey.totalTitleDeed);
    this.addIfHasValue(result.surveyNoVerification, 'totalEc', survey.totalEc);
    this.addIfHasValue(result.surveyNoVerification, 'difference', survey.difference);
    this.addIfHasValue(result.surveyNoVerification, 'missingEc', survey.missingEc);
    this.addIfHasValue(result.surveyNoVerification, 'type', survey.type);
    this.addIfHasValue(result.surveyNoVerification, 'pattaissuedverfy', survey.pattaissuedverfy);
    // pattaqrcode: REMOVED - boolean, comes from process_checklist/DataModel only
    // proofverifyqrcode: REMOVED - boolean, comes from process_checklist/DataModel only

    // Map titleDeed from API response - NO BOOLEAN FIELDS
    if (survey.titleDeed && Array.isArray(survey.titleDeed)) {
      console.log(`Mapping ${survey.titleDeed.length} titleDeed items`);
      
      result.surveyNoVerification.titleDeed = survey.titleDeed.map((item: any, index: number) => {
        console.log(`Processing titleDeed item ${index}:`, item);
        
        const mappedItem: any = {};

        // Only add fields that have values - Data from API - ONLY TEXT/NUMBER FIELDS, NO BOOLEANS
        this.addIfHasValue(mappedItem, 'surveyNo', item.surveyNo);
        this.addIfHasValue(mappedItem, 'oldSurveyNo', item.oldSurveyNo);
        this.addIfHasValue(mappedItem, 'extent', item.extent);
        this.addIfHasValue(mappedItem, 'name', item.name);
        this.addIfHasValue(mappedItem, 'deedlayoutnameverfy', item.deedlayoutnameverfy);
        this.addIfHasValue(mappedItem, 'deedstreetnameverfy', item.deedstreetnameverfy);
        this.addIfHasValue(mappedItem, 'deedplotNoverfy', item.deedplotNoverfy);
        this.addIfHasValue(mappedItem, 'measurementextentmatch', item.measurementextentmatch);
        this.addIfHasValue(mappedItem, 'deedDoorNoverfy', item.deedDoorNoverfy);
        this.addIfHasValue(mappedItem, 'deedflatnoverfy', item.deedflatnoverfy);
        this.addIfHasValue(mappedItem, 'floor', item.floor);
        this.addIfHasValue(mappedItem, 'deedapartnameverfy', item.deedapartnameverfy);
        this.addIfHasValue(mappedItem, 'boundverfyNorth', item.boundverfyNorth);
        this.addIfHasValue(mappedItem, 'boundverfySouth', item.boundverfySouth);
        this.addIfHasValue(mappedItem, 'boundverfyEast', item.boundverfyEast);
        this.addIfHasValue(mappedItem, 'boundverfyWest', item.boundverfyWest);
        this.addIfHasValue(mappedItem, 'Corelation', item.Corelation);
        this.addIfHasValue(mappedItem, 'proceedingpatta', item.proceedingpatta);
        this.addIfHasValue(mappedItem, 'deedExtentverfy', item.deedExtentverfy);
        this.addIfHasValue(mappedItem, 'sROVerified', item.sROVerified);
        this.addIfHasValue(mappedItem, 'tslrNo', item.tslrNo);

        // Extract boundary measurements if available
        if (Array.isArray(item.boundaries)) {
          console.log(`Item ${index} has boundaries:`, item.boundaries);
          item.boundaries.forEach((b: any) => {
            this.addIfHasValue(mappedItem, 'northeastMeasur', b.northeastMeasur);
            this.addIfHasValue(mappedItem, 'southeastMeasur', b.southeastMeasur);
            this.addIfHasValue(mappedItem, 'eastnorthMeasur', b.eastnorthMeasur);
            this.addIfHasValue(mappedItem, 'westnorthMeasur', b.westnorthMeasur);
          });
        }
        
        // ALL BOOLEAN FIELDS REMOVED - will come from process_checklist/DataModel only:
        // roadAppBound, pathwayBound, ofbyBoundverfy, landTypeNanjai, NonAgrifromtashidar,
        // newtalukVerified, deedapartcompletioncert, deedvillagename, deedregisterdistrict

        return mappedItem;
      });
    } else {
      console.log("No titleDeed array found or it's empty");
    }

    // Map currentPatta from API response - NO BOOLEAN FIELDS
    if (survey.currentPatta && Array.isArray(survey.currentPatta)) {
      result.surveyNoVerification.currentPatta = survey.currentPatta.map((item: any) => {
        const mappedItem: any = {};
        
        this.addIfHasValue(mappedItem, 'surveyNo', item.surveyNo);
        this.addIfHasValue(mappedItem, 'tslrNo', item.tslrNo);
        this.addIfHasValue(mappedItem, 'extent', item.extent);
        this.addIfHasValue(mappedItem, 'name', item.name);
        // governmentLandorNotverify: REMOVED - boolean, comes from process_checklist/DataModel only
        
        return mappedItem;
      });
    }

    // Map register from API response - NO BOOLEAN FIELDS
    if (survey.register && Array.isArray(survey.register)) {
      result.surveyNoVerification.register = survey.register.map((item: any) => {
        const mappedItem: any = {};
        
        this.addIfHasValue(mappedItem, 'surveyNo', item.surveyNo);
        this.addIfHasValue(mappedItem, 'tslrNo', item.tslrNo);
        this.addIfHasValue(mappedItem, 'extent', item.extent);
        this.addIfHasValue(mappedItem, 'name', item.name);
        this.addIfHasValue(mappedItem, 'aRegisterMeanscompare', item.aRegisterMeanscompare);
        // registerVerified: REMOVED - boolean, comes from process_checklist/DataModel only
        
        return mappedItem;
      });
    }

    console.log("Final mapped surveyNoVerification:", result.surveyNoVerification);
    return result;
  };

  // 4. Map deed data for ALL deed types - NO BOOLEAN FIELDS
  mapDeedData = (deed: any = {}) => {
    const mapped: any = {
      deed: {}
    };

    // Helper function to create deed entry - ONLY TEXT FIELDS
    const createDeedEntry = (item: any, type: string) => {
      const base: any = {};
      
      this.addIfHasValue(base, 'derivedBy', item.surveyNo || item.derivedBy);
      this.addIfHasValue(base, 'extent', item.extent);
      this.addIfHasValue(base, 'deedReference', item.deedReference);
      // registered: REMOVED - boolean, comes from process_checklist/DataModel only

      // Add relationship field based on deed type
      const relationship = item.relationship || 
                          item.relationshipMentioned || 
                          item.willdeadreationship || 
                          item.relationShipmentioned || 
                          item.partionRelationship;

      switch(type) {
        case "saleDeed":
          this.addIfHasValue(base, 'relationship', relationship);
          this.addIfHasValue(base, 'saleDeedConditions', item.saleDeedConditions);
          // ALL BOOLEAN FIELDS REMOVED:
          // saleDeedAmountTransfered, saleDeedConditionsMentioned
          break;
        case "giftDeed":
          this.addIfHasValue(base, 'relationshipMentioned', relationship);
          this.addIfHasValue(base, 'mentionCondition', item.mentionCondition);
          // ALL BOOLEAN FIELDS REMOVED:
          // condition, conditionFulfilled, deathcertificateobtained
          break;
        case "settlementDeed":
          this.addIfHasValue(base, 'relationshipMentioned', relationship);
          this.addIfHasValue(base, 'mentionCondition', item.mentionCondition);
          // ALL BOOLEAN FIELDS REMOVED:
          // condition, conditionFulfilled, deathcertificateobtained
          break;
        case "partitionDeed":
          this.addIfHasValue(base, 'partionRelationship', relationship);
          this.addIfHasValue(base, 'partionscheduleMortage', item.partionscheduleMortage);
          this.addIfHasValue(base, 'partionsimulatenous', item.partionsimulatenous);
          this.addIfHasValue(base, 'mentionCondition', item.mentionCondition);
          this.addIfHasValue(base, 'docAllotedForMortgage', item.docAllotedForMortgage);
          this.addIfHasValue(base, 'originalCopyAvailable', item.originalCopyAvailable);
          // ALL BOOLEAN FIELDS REMOVED:
          // condition, partiondeathcertobtin, conditionFulfilled
          break;
        case "willDeed":
          this.addIfHasValue(base, 'willdeadreationship', relationship);
          this.addIfHasValue(base, 'mentionCondition', item.mentionCondition);
          // ALL BOOLEAN FIELDS REMOVED:
          // condition, conditionFulfilled, willdeedcertcopyverify, willdeaddeathcert
          break;
        case "leaseDeed":
          this.addIfHasValue(base, 'relationship', relationship);
          this.addIfHasValue(base, 'leasePeriodFromDate', item.leasePeriodFromDate);
          this.addIfHasValue(base, 'leasePeriodToDate', item.leasePeriodToDate);
          // ALL BOOLEAN FIELDS REMOVED:
          // nocAvailable, leaseDeedempowermortage, leaseDeedCancellation
          break;
        case "attorneyDeed":
          this.addIfHasValue(base, 'relationship', relationship);
          // ALL BOOLEAN FIELDS REMOVED:
          // isInForce, isCertifiedCopyAvailable, attorneyDeedmortage, 
          // attorneyDeedsaleReceipt, attorneyLifecert
          break;
        case "releaseDeed":
          this.addIfHasValue(base, 'relationShipmentioned', relationship);
          this.addIfHasValue(base, 'propertyshare', item.propertyshare);
          this.addIfHasValue(base, 'mentionCondition', item.mentionCondition);
          // ALL BOOLEAN FIELDS REMOVED:
          // condition, fulFilled, deatcertficate
          break;
        case "rectificationDeed":
          this.addIfHasValue(base, 'relationship', relationship);
          this.addIfHasValue(base, 'mentionDetails', item.mentionDetails);
          this.addIfHasValue(base, 'correctDetails', item.correctDetails || item.correctDetailsx);
          break;
        case "consentDeed":
          this.addIfHasValue(base, 'relationship', relationship);
          this.addIfHasValue(base, 'reason', item.reason);
          // agecheckAadhar: REMOVED - boolean, comes from process_checklist/DataModel only
          break;
        case "gazetteofDoc":
          this.addIfHasValue(base, 'relationship', relationship);
          break;
      }
      
      return base;
    };

    // Process all deed types from API
    const deedTypes = [
      { key: "saleDeed", data: deed.saleDeed },
      { key: "giftDeed", data: deed.giftDeed },
      { key: "settlementDeed", data: deed.settlementDeed },
      { key: "partitionDeed", data: deed.partitionDeed },
      { key: "willDeed", data: deed.willDeed },
      { key: "leaseDeed", data: deed.leaseDeed },
      { key: "attorneyDeed", data: deed.attorneyDeed },
      { key: "releaseDeed", data: deed.releaseDeed },
      { key: "rectificationDeed", data: deed.rectificationDeed },
      { key: "consentDeed", data: deed.consentDeed },
      { key: "gazetteofDoc", data: deed.gazetteofDoc },
    ];

    deedTypes.forEach(({ key, data }) => {
      if (data && Array.isArray(data)) {
        mapped.deed[key] = data.map((item: any) => createDeedEntry(item, key));
      } else {
        // If no data from API, create empty array
        mapped.deed[key] = [];
      }
    });

    // Handle foreignPower separately - NO BOOLEAN FIELDS
    if (deed.foriegnPower && Array.isArray(deed.foriegnPower) && deed.foriegnPower.length > 0) {
      const docNo = deed.foriegnPower[0].docNo;
      if (this.hasValue(docNo)) {
        mapped.deed.foriegnPower = {
          // isForiegnPowerRegistered: REMOVED - boolean, comes from process_checklist/DataModel only
          docNo: docNo,
        };
      }
    }

    return mapped;
  };

  // 5. Map EB receipt data - NO BOOLEAN FIELDS
  mapEBreceiptData = (ebData: any = {}) => {
    const result: any = {
      EBreceiptData: {
        EBreceipt: []
      }
    };

    if (ebData && ebData.EBreceipt && Array.isArray(ebData.EBreceipt)) {
      result.EBreceiptData.EBreceipt = ebData.EBreceipt.map((item: any) => {
        const mappedItem: any = {};
        
        this.addIfHasValue(mappedItem, 'dateVerified', item.dateVerified);
        this.addIfHasValue(mappedItem, 'propertOwnerVerify', item.propertOwnerVerify);
        this.addIfHasValue(mappedItem, 'ebAmountverify', item.ebAmountverify);
        this.addIfHasValue(mappedItem, 'receiptIssuedByVerify', item.receiptIssuedByVerify);
        
        return mappedItem;
      });
    }

    return result;
  };

  // 6. Map property tax data - NO BOOLEAN FIELDS
  mapPropertyTaxData = (propertyTax: any = {}) => {
    const result: any = {
      propertytax: {
        propertytax: []
      }
    };

    if (propertyTax && propertyTax.propertytax && Array.isArray(propertyTax.propertytax)) {
      result.propertytax.propertytax = propertyTax.propertytax.map((item: any) => {
        const mappedItem: any = {};
        
        this.addIfHasValue(mappedItem, 'dataVerified', item.dataVerified);
        this.addIfHasValue(mappedItem, 'propertOwnerVerify', item.propertOwnerVerify);
        this.addIfHasValue(mappedItem, 'propertyAmountverify', item.propertyAmountverify);
        this.addIfHasValue(mappedItem, 'doorNoVerify', item.doorNoVerify);
        this.addIfHasValue(mappedItem, 'assessmentVerifi', item.assessmentVerifi);
        this.addIfHasValue(mappedItem, 'propertyTaxVerify', item.propertyTaxVerify);
        this.addIfHasValue(mappedItem, 'deedReference', item.deedReference);
        // ALL BOOLEAN FIELDS REMOVED:
        // propertyTaxVerifyQrcode, attachProofVerifyQrcode
        
        return mappedItem;
      });
    }

    return result;
  };

  // 7. Map legal heirs data from API - NO BOOLEAN FIELDS
  mapLegalHeirsData = (legalHeirsData: any = {}) => {
    const result: any = {
      legalHeirsVerify: {
        legalHeirs: []
      }
    };

    if (legalHeirsData && legalHeirsData.legalHeirs && Array.isArray(legalHeirsData.legalHeirs)) {
      // Merge all legalHeirs entries into one object
      const mergedLegalHeirs: any = {};
      // ALL BOOLEAN FIELDS REMOVED:
      // legalHeirsWithin13, PredeceasedlegalHeire, legalHeirsWithqrcode, legalHeirsattacedproof

      // Combine data from all legalHeirs entries - only fields with values
      legalHeirsData.legalHeirs.forEach((item: any) => {
        this.addIfHasValue(mergedLegalHeirs, 'legalHeirsObtained', item.legalHeirsObtained);
        this.addIfHasValue(mergedLegalHeirs, 'geanology', item.geanology);
        this.addIfHasValue(mergedLegalHeirs, 'docNoAndYear', item.docNoAndYear);
        this.addIfHasValue(mergedLegalHeirs, 'nextDeedDocNoAndYear', item.nextDeedDocNoAndYear);
      });

      result.legalHeirsVerify.legalHeirs = [mergedLegalHeirs];
    }

    return result;
  };

  // 8. Map HSD pattas data from API - NO BOOLEAN FIELDS
  mapHsdpPattaData = (hsdpData: any = {}) => {
    const result: any = {
      HsdpattasVerify: {
        Hsdpattas: []
      }
    };

    if (hsdpData && hsdpData.Hsdpattas && Array.isArray(hsdpData.Hsdpattas) && hsdpData.Hsdpattas.length > 0) {
      result.HsdpattasVerify.Hsdpattas = hsdpData.Hsdpattas.map((item: any) => {
        const mappedItem: any = {};
        
        this.addIfHasValue(mappedItem, 'hsdpattaissuedby', item.hsdpattaissuedby);
        this.addIfHasValue(mappedItem, 'mentionCondition', item.mentionCondition);
        // ALL BOOLEAN FIELDS REMOVED:
        // roadApproachs, certificate, nocforTahsildar, conditionFullfilled
        
        return mappedItem;
      });
    }

    return result;
  };


  // 9. Complete normalizeDynamicChecklist function
  normalizeDynamicChecklist = (apiData: any = {}) => {
    let normalized: any = {};

    // 1. Map propertyDetails
    if (apiData.propertyDetails) {
      normalized.generalVerification = this.mapPropertyDetails(apiData.propertyDetails);
    }

    // 2. Map missingLOD
    if (apiData.missingLOD) {
      const missingData = this.mapMissingLOD(apiData.missingLOD);
      normalized.missingLOD = missingData.missingLOD;
    }

    // 3. Map survey verification
    if (apiData.surveyNoVerification) {
      const surveyData = this.mapSurveyVerification(apiData.surveyNoVerification);
      normalized.surveyNoVerification = surveyData.surveyNoVerification;
    }

    // 4. Map deed data
    if (apiData.deed) {
      const deedData = this.mapDeedData(apiData.deed);
      normalized.deed = deedData.deed;
    }

    // 5. Map EB receipt
    if (apiData.EBreceiptData) {
      const ebData = this.mapEBreceiptData(apiData.EBreceiptData);
      normalized.EBreceiptData = ebData.EBreceiptData;
    }

    // 6. Map property tax
    if (apiData.propertytax) {
      const taxData = this.mapPropertyTaxData(apiData.propertytax);
      normalized.propertytax = taxData.propertytax;
    }

    // 7. Map legal heirs
    if (apiData.legalHeirsVerify) {
      const legalHeirsData = this.mapLegalHeirsData(apiData.legalHeirsVerify);
      normalized.legalHeirsVerify = legalHeirsData.legalHeirsVerify;
    }

    // 8. Map HSD pattas
    if (apiData.HsdpattasVerify) {
      const hsdpData = this.mapHsdpPattaData(apiData.HsdpattasVerify);
      normalized.HsdpattasVerify = hsdpData.HsdpattasVerify;
    }

    return normalized;
  };

  getFormData = () => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const fileId = this.props.match.params.id;

    this.setState({ formDataLoading: true });

    // List of fields that should ONLY come from process_checklist or DataModel
    const booleanOnlyFields = new Set([
      // propertyDetails verified fields
      'generalVerification.ownerAadharName.verified',
      'generalVerification.borrowerAadharName.verified',
      'generalVerification.coBorrowerAadharName.verified',
      'generalVerification.addressofProperty.verified',
      'generalVerification.natureofProperty.verified',
      'generalVerification.AppIdverfy.verified',
      'generalVerification.freeRleasehold.verified',
      'generalVerification.ownerShip.verified',

      // surveyNoVerification section-level boolean fields
      'surveyNoVerification.pattaqrcode',
      'surveyNoVerification.proofverifyqrcode',
      'surveyNoVerification.conditionPatta',

      // surveyNoVerification.titleDeed array boolean fields
      'surveyNoVerification.titleDeed.roadAppBound',
      'surveyNoVerification.titleDeed.pathwayBound',
      'surveyNoVerification.titleDeed.ofbyBoundverfy',
      'surveyNoVerification.titleDeed.landTypeNanjai',
      'surveyNoVerification.titleDeed.NonAgrifromtashidar',
      'surveyNoVerification.titleDeed.newtalukVerified',
      'surveyNoVerification.titleDeed.deedapartcompletioncert',
      'surveyNoVerification.titleDeed.deedvillagename',
      'surveyNoVerification.titleDeed.deedregisterdistrict',
      'surveyNoVerification.titleDeed.new',

      // surveyNoVerification.currentPatta array boolean fields
      'surveyNoVerification.currentPatta.governmentLandorNotverify',

      // surveyNoVerification.register array boolean fields
      'surveyNoVerification.register.registerVerified',
    ]);

    // Smart merge that respects field priority and boolean-only restrictions
    const smartMerge = (target: any, source: any, trackedFields: Set<string>, parentPath: string = "", skipBooleanOnlyFields: boolean = false) => {
      if (!source || typeof source !== "object") return;

      for (const key in source) {
        if (!source.hasOwnProperty(key)) continue;

        const val = source[key];
        const currentPath = parentPath ? `${parentPath}.${key}` : key;

        // Skip boolean-only fields if this source is not allowed to set them
        if (skipBooleanOnlyFields && booleanOnlyFields.has(currentPath)) {
          continue;
        }

        // Handle arrays
        if (Array.isArray(val)) {
          if (!target[key] || !Array.isArray(target[key])) {
            target[key] = [];
          }

          // Merge array items
          val.forEach((item, idx) => {
            if (!target[key][idx]) {
              target[key][idx] = {};
            }

            if (item && typeof item === "object" && !Array.isArray(item)) {
              // For array items, check if any of their properties are boolean-only fields
              for (const itemKey in item) {
                if (!item.hasOwnProperty(itemKey)) continue;

                const itemPath = `${currentPath}.${itemKey}`;
                const itemVal = item[itemKey];

                // Skip boolean-only fields
                if (skipBooleanOnlyFields && booleanOnlyFields.has(itemPath)) {
                  continue;
                }

                const fullPath = `${currentPath}[${idx}].${itemKey}`;

                if (itemVal && typeof itemVal === "object" && !Array.isArray(itemVal)) {
                  if (!target[key][idx][itemKey]) {
                    target[key][idx][itemKey] = {};
                  }
                  smartMerge(target[key][idx][itemKey], itemVal, trackedFields, fullPath, skipBooleanOnlyFields);
                } else if (itemVal !== undefined && itemVal !== null && itemVal !== '') {
                  if (!trackedFields.has(fullPath)) {
                    target[key][idx][itemKey] = itemVal;
                    trackedFields.add(fullPath);
                  }
                }
              }
            } else if (item !== undefined && item !== null && item !== '') {
              const fieldPath = `${currentPath}[${idx}]`;
              if (!trackedFields.has(fieldPath)) {
                target[key][idx] = item;
                trackedFields.add(fieldPath);
              }
            }
          });
        }
        // Handle objects
        else if (val && typeof val === "object" && !Array.isArray(val)) {
          if (!target[key] || typeof target[key] !== "object") {
            target[key] = {};
          }
          smartMerge(target[key], val, trackedFields, currentPath, skipBooleanOnlyFields);
        }
        // Handle primitive values (including booleans, strings, numbers)
        else if (val !== undefined && val !== null && val !== '') {
          // Only set if this field hasn't been set before
          if (!trackedFields.has(currentPath)) {
            target[key] = val;
            trackedFields.add(currentPath);
          }
        }
      }
    };

    // 1. get_dynamic_verificationchecklist.php
    const dynamicPromise = callApi("POST", "get_dynamic_verificationchecklist.php", {
      fileNo: fileId,
      userId,
    })
      .then((res) => res.data)
      .then((response) => (response?.data ? this.normalizeDynamicChecklist(response.data) : {}))
      .catch(() => ({}));

    // 2. get_verification.php
    const verificationPromise = callApi("POST", "get_verification.php", {
      fileNo: fileId,
    })
      .then((res) => res.data)
      .then((response) => {
        this.setState({ verificationEOD: response?.eod_submit });
        return response?.data || {};
      })
      .catch(() => ({}));

    // 3. get_process_checklist.php
    const processChecklistPromise = callApi("POST", "get_verification_checklist.php", {
      fileNo: fileId,
      userId,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response?.responseJson?.data?.currentJson) {
          try {
            this.setState({
              verificationEOD:
                response?.responseJson?.data?.eod_submit == true ? true : false,
            });
            return JSON.parse(response.responseJson.data.currentJson);
          } catch {
            return {};
          }
        }
        return {};
      })
      .catch(() => ({}));

    // Resolve all promises
    Promise.all([dynamicPromise, verificationPromise, processChecklistPromise])
      .then(([dynamicData, verificationData, processChecklistData]) => {
        // Start with DataModel as base
        let finalData = JSON.parse(JSON.stringify(DataModel)); // Deep clone

        // Track which fields have been set (to prevent overwriting)
        const trackedFields = new Set<string>();

        // Priority order (first one wins):
        // 1. Dynamic API (highest priority) - SKIP boolean-only fields
        if (Object.keys(dynamicData).length > 0) {
          console.log("Merging Dynamic API data (Priority 1) - skipping boolean-only fields");
          smartMerge(finalData, dynamicData, trackedFields, "", true);
        }

        // 2. Verification API (fills in fields not in Dynamic) - SKIP boolean-only fields
        if (Object.keys(verificationData).length > 0) {
          console.log("Merging Verification API data (Priority 2) - skipping boolean-only fields");
          smartMerge(finalData, verificationData, trackedFields, "", true);
        }

        // 3. Process Checklist API (fills in remaining fields including ALL booleans)
        if (Object.keys(processChecklistData).length > 0) {
          console.log("Merging Process Checklist API data (Priority 3) - includes boolean-only fields");
          smartMerge(finalData, processChecklistData, trackedFields, "", false);
        }

        // 4. DataModel already used as base (lowest priority - default values)

        console.log("Final tracked fields:", trackedFields.size, "fields set");
        console.log("Boolean-only fields protected:", booleanOnlyFields.size);

        this.ensureRequiredArrays(finalData);
        this.setState({ data: finalData, formDataLoading: false });
      })
      .catch((error) => {
        console.error("Error fetching form data:", error);
        this.setState({ data: DataModel, formDataLoading: false });
      });
  };

  // Helper function to ensure all required arrays exist
  ensureRequiredArrays = (data: any) => {
    const sectionsWithArrays = [
      { path: 'surveyNoVerification.titleDeed', defaultValue: DataModel.surveyNoVerification.titleDeed[0] },
      { path: 'surveyNoVerification.currentPatta', defaultValue: DataModel.surveyNoVerification.currentPatta[0] },
      { path: 'surveyNoVerification.register', defaultValue: DataModel.surveyNoVerification.register[0] },
      { path: 'deed.saleDeed', defaultValue: DataModel.deed.saleDeed[0] },
      { path: 'deed.giftDeed', defaultValue: DataModel.deed.giftDeed[0] },
      { path: 'deed.settlementDeed', defaultValue: DataModel.deed.settlementDeed[0] },
      { path: 'deed.partitionDeed', defaultValue: DataModel.deed.partitionDeed[0] },
      { path: 'deed.willDeed', defaultValue: DataModel.deed.willDeed[0] },
      { path: 'deed.leaseDeed', defaultValue: DataModel.deed.leaseDeed[0] },
      { path: 'deed.attorneyDeed', defaultValue: DataModel.deed.attorneyDeed[0] },
      { path: 'deed.releaseDeed', defaultValue: DataModel.deed.releaseDeed[0] },
      { path: 'deed.rectificationDeed', defaultValue: DataModel.deed.rectificationDeed[0] },
      { path: 'deed.consentDeed', defaultValue: DataModel.deed.consentDeed[0] },
      { path: 'missingLOD.sheets', defaultValue: DataModel.missingLOD.sheets[0] },
      { path: 'legalHeirsVerify.legalHeirs', defaultValue: DataModel.legalHeirsVerify.legalHeirs[0] },
      { path: 'HsdpattasVerify.Hsdpattas', defaultValue: DataModel.HsdpattasVerify.Hsdpattas[0] },
      { path: 'propertytax.propertytax', defaultValue: DataModel.propertytax.propertytax[0] },
      { path: 'EBreceiptData.EBreceipt', defaultValue: DataModel.EBreceiptData.EBreceipt[0] },
    ];

    sectionsWithArrays.forEach(({ path, defaultValue }) => {
      const keys = path.split('.');
      let current = data;

      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) {
          current[keys[i]] = {};
        }
        current = current[keys[i]];
      }

      const lastKey = keys[keys.length - 1];
      if (!current[lastKey] || !Array.isArray(current[lastKey]) || current[lastKey].length === 0) {
        current[lastKey] = [{ ...defaultValue }];
      }
    });
  };

  handleGeneralVerifyChange = (modData) => {
    const { data } = this.state;
    data.generalVerification = modData;
    this.setState({ data });
  };
  handleHsdpattaChange = (modData) => {
    const { data } = this.state;
    data.HsdpattasVerify = modData;
    this.setState({ data });
  };
  handleNathampattaChange = (modData) => {
    const { data } = this.state;
    data.nathamPattaverify = modData;
    this.setState({ data });
  };
  handleFlowChange = (modData) => {
    const { data } = this.state;
    data.flow = modData;
    this.setState({ data });
  };
  handlePropertytaxChange = (modData) => {
    const { data } = this.state;
    data.propertytax = modData;
    this.setState({ data });
  };
  handleEBreceiptChange = (modData) => {
    const { data } = this.state;
    data.EBreceiptData = modData;
    this.setState({ data });
  };
  handleSurveyNoVerifyChange = (modData) => {
    const { data } = this.state;
    data.surveyNoVerification = modData;
    this.setState({ data });
  };
  handleDeedChange = (modData) => {
    const { data } = this.state;
    data.deed = modData;
    this.setState({ data });
  };
  handleLegalHerisChange = (modData) => {
    const { data } = this.state;
    data.legalHeirsVerify = modData;
    this.setState({ data });
  };
  handleEcVerifyChange = (modData) => {
    const { data } = this.state;
    data.ecVerify = modData;
    this.setState({ data });
  };
  handleLodChange = (modData) => {
    const { data } = this.state;
    data.missingLOD = modData;
    this.setState({ data });
  };
  handleVerifyChange = (modData) => {
    const { data } = this.state;
    data.verification = modData;
    this.setState({ data });
  };
  handleCourtVerifyChange = (modData) => {
    const { data } = this.state;
    data.courtDocVerification = modData;
    this.setState({ data });
  };
  handleOriginalDocVerifyChange = (modData) => {
    const { data } = this.state;
    data.originalDocVerification = modData;
    this.setState({ data });
  };
  handleChange = (e) => {
    const { data } = this.state;
    data.isVerified = e.target.checked;
    this.setState({ data });
  };
  actionHandle = (action) => {
    this.setState({ action });
  };
  uploadFile = (file: any) => {
    this.setState({ uploadFile: file });
  };
  handleReasonChange = (e) => {
    this.setState({ reason: e.target.value });
  };
  setVerify = (verify) => {
    this.setState({ verification: verify });
    // this.setState({ isComplete: true });
  };
  validateReason = () => {
    if (this.state.reason === "") {
      ToastsStore.error("Please Enter Reason");
    } else {
      if (this.state.action === "download") {
        this.downloadDoc();
      } else {
        $("#reason-modal").modal("hide");
        this.uploadDoc();
        // $("#verification-modal").modal("show");
      }
    }
  };
  downloadDoc = () => {
    $("#reason-modal").modal("hide");
    const props: any = this.props;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const obj = {
      fileid: props.match.params.id,
      reason: this.state.reason,
      createdBy: userId,
    };
    callApi("POST", "download_log.php", obj)
      .then((res) => res)
      .then((response) => {
        if (response.status === 200) {
          // ToastsStore.success("work file Q & A are saved succesfully")
          ToastsStore.success("Reason saved successfully");
          this.downloadDocs();
          this.clearModal();
        } else {
          ToastsStore.error("Error in storing, Please try again!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  //Download docs from external api
  downloadDocs = () => {
    const { lastUploadedDocument } = this.state;
    if (lastUploadedDocument.docx) {
      callApi("POST", "get_branch_code.php", {
        id: this.props.match.params.id,
      })
        .then((res) => res.data)
        .then((response) => {
          const name = `${response.data[0].lawhands_branch}-${this.props.match.params.id}.docx`;
          saveAs(lastUploadedDocument.docx, name);
        });
    } else {
      const props: any = this.props;
      // ToastsStore.success("Downloaded Successful!");
      callApi("POST", "template/tests/shell.php", {
        id: props.match.params.id,
        responseType: "blob",
      })
        .then((res) => res.data)
        .then((response) => {
          //ToastsStore.success("Downloaded Successfully!");
          window.open(
            API_ENDPOINT +
            "template/tests/shell.php?id=" +
            props.match.params.id,
            "_self"
          );
        });
    }
  };

  enableModalHandler = () => {
    // $("#complete-process").modal("show");
    if (
      this.state.blockdownload == "true" &&
      this.state.fileOpinionType == "1"
    ) {
      // this.completeModalHandler();
      if (this.state.filestatus != "5") {
        this.uploadDoc();
      } else {
        ToastsStore.error("Completed File can't be processed");
      }
    } else {
      $("#complete-process").modal("show");
    }
  };

  verificationtime(type, holdType) {
    const props: any = this.props;
    const loginuser: any = localStorage.getItem("user1");
    var now = new Date();
    var date = now.toLocaleDateString();
    var time = now.toLocaleTimeString();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const currenttime = `${hours}:${minutes}:${seconds}`;
    const currentdate = moment(date).format("YYYY-MM-DD");
    let obj;
    if (type == "hold") {
      obj = {
        id: props.match.params.id,
        verification_hold_time: currenttime,
        verification_hold_date: currentdate,
        verification_hold_by: JSON.parse(loginuser),
        reason: holdType,
        created_by: JSON.parse(loginuser),
        color: "gray",
      };
    } else {
      // obj = {
      //   id: props.match.params.id,
      //   verification_completed_time: currenttime,
      //   verification_completed_date: currentdate,
      //   verification_completed_by: JSON.parse(loginuser),
      //   reason: "Verification Completed",
      //   created_by: JSON.parse(loginuser),
      // };
    }
    callApi("POST", "time_update.php", obj)
      .then((res) => res.data)
      .then((response) => { });
  }

  checkVerifyRestriction = async () => {
    const response = await callApi("POST", "verify_check_restriction.php", {
      id: this.props.match.params.id,
      file_status: 5,
      flag: "complete",
    }).then((res) => res.data);

    if (response.response_Code === 201) {
      this.setState({ fileNotCompleteMsg: { __html: response.message } });
      $("#file_not_complete_modal").modal("show");
      return true;
    }

    return false;
  };

  completeModalHandler = async () => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    if (
      this.state.verificationEOD == true &&
      this.state.data.isVerified == true
    ) {
      const checkRestrict = await this.checkVerifyRestriction();
      if (checkRestrict) return;

      this.setState({ isLoading: true });
      const props: any = this.props;
      this.setState({ showTitle: true });
      callApi("POST", "file_status.php", {
        id: props.match.params.id,
        file_status: 5,
        userId: userId,
      })
        .then((res) => res)
        .then((response) => {
          if (response.status === 200) {
            localStorage.removeItem("currentfileId");
            // this.verificationtime("complete");
            this.setState({ showTitle: false, isLoading: false });
            $("#processComplete").modal("show");
            const user: any = localStorage.getItem("user");
            const userId = user ? JSON.parse(user)["userId"] : "";
            const userName = user ? JSON.parse(user)["firstName"] : "";
            const notifyData = {
              title: `${this.props.match.params.id}Verification Completed By ${userName}`,
              notifyType: "message",
              updatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
            };
            let user_id = userId;
            pushnotificationApi(notifyData, userId);
            const branchManger: any = localStorage.getItem("branch_manager");
            const branch_Manager = JSON.parse(branchManger);
            const queryOfficer: any = localStorage.getItem("Query_officer");
            const query_ooficer = JSON.parse(queryOfficer);
            const Scan_officer: any = localStorage.getItem("scan_officer");
            const sacanofficer = JSON.parse(Scan_officer);
            const process_mennager: any =
              localStorage.getItem("process_manager");
            const processManager = JSON.parse(process_mennager);
            if (Array.isArray(branch_Manager) && branch_Manager.length > 0) {
              notifyToUser(
                "user",
                { ...notifyData, notifyType: "message" },
                branch_Manager
              );
              const BranchManager = branch_Manager.join(",");
              let obj = {
                notification_type: "verificationcomplete",
                user_id: BranchManager,
                ...notifyData,
                reason: `${this.props.match.params.id}Verification Completed`,
              };
              callApi("POST", "pushnotification.php", obj)
                .then((res) => res.data)
                .then((response) => { })
                .catch((err) => {
                  console.log(err);
                });
            }
            //   if (Array.isArray(query_ooficer) && query_ooficer.length > 0) {
            //     notifyToUser("user", { ...notifyData, notifyType: "notify" }, query_ooficer);
            //   }
            // if (Array.isArray(sacanofficer) && sacanofficer.length > 0) {
            //   notifyToUser("user", { ...notifyData, notifyType: "message" }, sacanofficer);
            // }
            if (Array.isArray(processManager) && processManager.length > 0) {
              notifyToUser(
                "user",
                { ...notifyData, notifyType: "message" },
                processManager
              );
              const ProcessManager = processManager.join(",");
              let obj = {
                user_id: ProcessManager,
                ...notifyData,
                reason: `${this.props.match.params.id}Verification Completed`,
              };
              callApi("POST", "pushnotification.php", obj)
                .then((res) => res.data)
                .then((response) => { })
                .catch((err) => {
                  console.log(err);
                });
            }
            // this.props.history.push("/work-file-verification-list/"+ props.match.params.id);
          } else {
            this.setState({ isLoading: false });
            ToastsStore.error(
              "Error in completing the file , Please try again!"
            );
          }
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          console.log(err);
        });
    } else {
      ToastsStore.error("Please fill the Verification EOD to proceed");
    }
  };
  verifyModalHandler = () => {
    $("#verification-modal").modal("show");
  };
  close = () => {
    $("#processComplete").modal("hide");
    // this.props.history.push("/completed-file");
    this.props.history.push("/inprogress-file");
    localStorage.removeItem("updatedRemainingTime");
  };

  uploadDoc = async () => {
    if (
      this.state.verificationEOD == true &&
      this.state.data.isVerified == true
    ) {
      const checkRestrict = await this.checkVerifyRestriction();
      if (checkRestrict) return;

      const props: any = this.props;
      const user: any = localStorage.getItem("user");
      const userId = user ? JSON.parse(user)["userId"] : "";
      const serverLocalFileName = localStorage.getItem("serverLocalFileName");

      const obj: any = { ...this.state.verification };
      obj.fileId = props.match.params.id;
      obj.reason =
        this.state.blockdownload === "true" && this.state.fileOpinionType == "1"
          ? "Verification Completed"
          : this.state.reason;
      obj.serverLocalFileName =
        this.state.blockdownload === "true" && this.state.fileOpinionType == "1"
          ? this.state.serverLocalFileName || serverLocalFileName
          : "";
      obj.file = this.state.uploadFile.base64.split(",")[1];
      obj.createdBy = userId;
      const errorTypes: any = [];
      obj.errorTypes.forEach((type: any) => {
        errorTypes.push({ type });
      });
      obj.errorTypes = errorTypes.length > 0 ? errorTypes : ["1", "2"];
      obj.errorSection = ["1", "2"];

      callApi("POST", "template/tests/upload_log.php", obj)
        .then((res) => res.data)
        .then((response) => {
          if (response.status === 200) {
            this.setState({ isComplete: false });
            if (
              this.state.blockdownload == "true" &&
              this.state.fileOpinionType == "1"
            ) {
              this.completeModalHandler();
            } else {
              ToastsStore.success("Reason saved successfully");
            }
            this.getUpdateReasonData();
            this.clearModal();
          } else {
            ToastsStore.error(response.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      ToastsStore.error("Please fill the Verification EOD to proceed");
    }
  };

  liveinsert = () => {
    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["team_type"] : "";
    const userId = user ? JSON.parse(user)["userId"] : "";
    const role = user ? JSON.parse(user)["teamType"] : "";
    const role_type = user ? JSON.parse(user)["roleType"] : "";
    const user_name = user ? JSON.parse(user)["userName"] : "";
    const bankName: any = localStorage.getItem("bankName");
    const fileNamCode: any = localStorage.getItem("fileNamCode");
    const in_reason: any = localStorage.getItem("in_reason");
    let dateTime = new Date();
    let curentTime = dateTime.toLocaleTimeString();
    const textRay = `Currently Working On Verification File No  : ${this.props.match.params.id}`;
    let obj = {
      file_no: fileNamCode,
      in_time: curentTime,
      reason: in_reason,
      user_id: userId,
      user_name: user_name,
      team_type: role,
      role_type: role_type,
      working_process: textRay,
      bank_name: bankName,
    };
    console.log("231", obj);
    callApi("POST", "live_track_insert.php", obj)
      .then((res) => res.data)
      .then((response) => { });
  };

  clearModal = () => {
    // const state ={
    //     isComplete:true
    // }
    const verification = {
      highlight: false,
      dataEntry: false,
      flowChart: false,
      hintFile: false,
      errorIdentified: false,
      noOflod: "",
      errorSection: [],
      otherSection: "",
      errorTypes: [],
      errorDetails: "",
      totalTime: "",
      userId: "",
      fileId: "",
    };
    this.setState({
      reason: "",
      verification,
    });
  };
  // completeEnable = () =>{
  //     // const {isComplete}
  //     this.setState({isComplete: true});
  // }
  verificationEODHandler = () => {
    $("#verification-modal").modal("hide");
    const { verification } = this.state;
    // this.setState({isComplete : true});
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    verification.userId = userId;
    verification.fileId = this.props.match.params.id;

    console.log("verification", verification);
    callApi("POST", "verification_eod.php", {
      fileNo: this.props.match.params.id,
      eodData: JSON.stringify(verification),
      user_id: userId,
    })
      .then((res) => res)
      .then((response: any) => {
        if (response.status === 200) {
          this.setState({ verificationEOD: true });
          ToastsStore.success("verification saved successfully");
          // this.completeFlowHandler()
          this.props.history.push(
            "/work-file-verification-list/" + this.props.match.params.id
          );
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ verificationEOD: false });
      });
  };
  saveVerification = () => {
    const { data } = this.state;
    const props: any = this.props;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    if (!data.remarks) {
      ToastsStore.error("Enter Remarks!");
    } else {
      const obj = {
        fileNo: props.match.params.id,
        currentData: data,
        oldData: data,
        loginId: userId,
      };
      callApi("POST", "verification_checklist.php", obj)
        .then((res) => res.data)
        .then((response) => {
          ToastsStore.success("verification checklist saved");
        });
    }
  };
  updatedRemainingTime(time) {
    this.setState(
      (prevState: any) => ({
        updatedRemainingTime: time,
      }),
      () => { }
    );
  }
  onchange = (e: any) => {
    e.persist();
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (
          this.state.holdType == "Hold Query Raised" &&
          e.target.name == "holdType"
        ) {
          this.addQueryList();
        } else if (
          this.state.holdType == "Hold" &&
          e.target.name == "holdType"
        ) {
          this.setState({ newQueryList: [] });
        }
      }
    );
  };

  handleHoldFile = async () => {
    this.setState({ holdVal: true });
    const { holdreason, holdType, newQueryList } = this.state;

    if (isEmpty(holdreason) || isEmpty(holdType)) {
      ToastsStore.error("Please Select Type and Provide Reason to Hold");
      return;
    }

    if (holdType == "Hold Query Raised") {
      if (newQueryList && newQueryList.length > 0) {
        const isValid = await this.validateQuery(newQueryList);
        if (isValid) {
          await this.updateNewQueryList();
        } else {
          ToastsStore.error("Please fill all the required fields");
          return;
        }
      }
    } else {
      this.holdFile();
    }
  };

  holdFile = () => {
    const { holdreason, holdType } = this.state;

    const props: any = this.props;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    this.setState({ isLoading: true });
    const obj = {
      file_id: props.match.params.id,
      hold_by: userId,
      reason: holdreason,
      holdType: holdType,
    };
    callApi("POST", "hold_file.php", obj)
      .then((res) => res.data)
      .then((response) => {
        if (response.statuscode == 200) {
          ToastsStore.success(response.message);
          $("#holdModal").modal("hide");
          this.verificationtime("hold", holdType);
          this.setState({ holdVal: false, holdreason: "", isLoading: false });
          localStorage.removeItem("currentfileId");
          this.props.history.push("/inprogress-file");
        } else {
          ToastsStore.error(response.message);
        }
      });
  };

  updateNewQueryList = async () => {
    const { remote_users, queryBase, remote_cc_users, newQueryList } =
      this.state;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const mailToBank: any = localStorage.getItem("mail-bank");
    const userDGrade: any = localStorage.getItem("user_d_grade");
    const fileDGrade: any = localStorage.getItem("file_d_grade");

    const payload: any = {
      querydetail: newQueryList,
      remote_users: remote_users,
      remote_cc_users,
      user_idfk: userId,
      fod_fk: this.props.match.params.id,
      base: queryBase,
    };
    if (payload && payload.querydetail.length > 0) {
      if (userDGrade === "D" || fileDGrade === "D") {
        if (mailToBank === "true") {
          $("#send-mail").modal("show");
        } else {
          // without mail raise query
          this.saveQuery();
        }
      } else {
        $("#send-mail").modal("show");
      }
    }
    this.getQueryQuestion();
    this.getUsers();
  };

  getQueryQuestion = () => {
    callApi("POST", "query_question_get.php")
      .then((res) => res.data)
      .then((response) => {
        this.setState({
          queryQues: response.data,
          oldQueryQues: JSON.parse(JSON.stringify(response.data)),
        });
      });
  };

  validateQuery = (querydetail) => {
    let base = querydetail;

    let isValid;
    for (let i = 0; i < base.length; i++) {
      const document = base[i];
      if (document && document.review == "other") {
        if (!document.query || !document.review || !document.other_review) {
          isValid = false;
          base[i].isValid = false;
        } else {
          isValid = true;
          base[i].isValid = true;
        }
      } else if (document && document.review != "other") {
        if (!document.query || !document.review) {
          isValid = false;
          base[i].isValid = false;
        } else {
          isValid = true;
          base[i].isValid = true;
        }
      }
    }
    return isValid;
  };

  saveQuery = (): void => {
    const { remote_users, queryBase, remote_cc_users, newQueryList } =
      this.state;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const process_office_id: any = localStorage.getItem("process_office_id");
    const userid1: any = localStorage.getItem("user1");

    // Initialize querydetail
    let querydetail: any[] = [];

    // Step 1: Add multiSelectedQuery
    querydetail = newQueryList;

    // Step 2: Sort querydetail by filter_date
    querydetail.sort((a, b) => {
      const dateA = moment(a.filter_date, "DD-MM-YYYY HH:mm:ss").toDate();
      const dateB = moment(b.filter_date, "DD-MM-YYYY HH:mm:ss").toDate();
      return dateA.getTime() - dateB.getTime(); // Ascending order
    });

    const payload: any = {
      querydetail,
      remote_users: remote_users,
      remote_cc_users,
      user_idfk: userId,
      fod_fk: this.props.match.params.id,
      base: queryBase,
    };
    // console.log("payload___", payload, multiSelectedQuery, this.state.newquery);
    // return;
    this.setState({ queryLoading: true });
    const userDGrade: any = localStorage.getItem("user_d_grade");
    const fileDGrade: any = localStorage.getItem("file_d_grade");
    const mailToBank: any = localStorage.getItem("mail-bank");
    let apiPath;
    if (userDGrade === "D" || fileDGrade === "D") {
      apiPath =
        mailToBank === "true"
          ? "verification_query_create.php"
          : "verification_query_create_without_mail.php";
      this.deviationFileLog(this.props.match.params.id);
    } else {
      apiPath = "verification_query_create.php";
    }
    callApi("POST", apiPath, payload)
      .then((res) => res.data)
      .then((response) => {
        if (response.success == true) {
          // hold file
          this.holdFile();
          $("#send-mail").modal("hide");
          ToastsStore.success("Queries raised Successully");

          localStorage.setItem("query_raised_status", JSON.stringify(true));
          this.setState({ queryLoading: false, quesSubmitted: false });
          this.setState({
            queryPayload: {
              requery: [],
              resend: [],
            },
            multiSelectedQuery: [],
            newquery: [],
          });
        } else {
          this.setState({ queryLoading: false, quesSubmitted: false });
          ToastsStore.error("Something went Wrong, Please try again!");
        }
      })
      .catch((err) => {
        this.setState({ queryLoading: false, quesSubmitted: false });
        ToastsStore.error("Something went Wrong, Please try again!");
      });
  };

  addQueryList = () => {
    const { newQueryList } = this.state;
    newQueryList.push({
      query: "",
      location: "",
      review: "",
      is_checked: false,
      other_review: "",
      created_date: moment().format("DD-MM-YYYY HH:mm:ss"),
    });
    this.setState({ newQueryList });
  };

  handleChangequery = (e: any, index: number) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    const { newQueryList } = this.state;
    newQueryList[index][fieldName] = fieldValue;
    this.setState({ newQueryList });
  };

  handleDetailsChange = (value: string, key: string, index: number) => {
    const { newQueryList } = this.state;
    newQueryList[index][key] = value;
    this.setState({ newQueryList });
  };

  removeReply = (index) => {
    const { newQueryList } = this.state;
    const updatedQueryList = [
      ...newQueryList.slice(0, index),
      ...newQueryList.slice(index + 1),
    ];
    this.setState({ newQueryList: updatedQueryList });
  };

  newaddrequery = (data: any) => {
    const { reQueryList, newQueryList } = this.state;
    const newReQueryItem = {
      query: "",
      location: "",
      review: "",
      query_id: data.id ? data.id : data.query_id,
      other_review: "",
      created_date: moment().format("DD-MM-YYYY HH:mm:ss"),
    };
    const updatedReQueryList = [...reQueryList, newReQueryItem];
    const updatedNewQueryList = [...newQueryList, newReQueryItem];

    this.setState({
      reQueryList: updatedReQueryList,
      newQueryList: updatedNewQueryList,
    });
  };

  selectUser = (e: any, user: any) => {
    let remote_users: any = this.state.remote_users;
    if (e.target.checked) {
      remote_users.push({ email: user.email, name: user.name });
    } else {
      remote_users = remote_users.filter((itm) => itm.email !== user.email);
    }
    this.setState({ remote_users });
  };
  selectCcUser = (e: any, user: any) => {
    let remote_users: any = this.state.remote_cc_users;
    if (e.target.checked) {
      remote_users.push({ email: user.email, name: user.name });
    } else {
      remote_users = remote_users.filter((itm) => itm.email !== user.email);
    }
    this.setState({ remote_cc_users: remote_users });
  };

  handleAnswerChange = (index, val) => {
    const queryQues: any = this.state.queryQues;
    queryQues[index].answer = val;
    this.setState({ queryQues });
  };
  saveQueryQuestion = () => {
    const { queryQues, oldQueryQues } = this.state;
    const user: any = localStorage.getItem("user");
    const obj = {
      fileNo: this.props.match.params.fileid,
      currentData: queryQues,
      oldData: oldQueryQues,
      loginId: user ? JSON.parse(user)["userId"] : "",
    };

    callApi("POST", "queryverification_checklist.php", obj)
      .then((res) => res.data)
      .then((response) => {
        this.setState({ quesSubmitted: true });
      })
      .catch((err) => { });
  };

  addItem = (): void => { };

  deviationFileLog = (fileid) => {
    const loginuser: any = localStorage.getItem("user1");
    let req = {
      query_raised_by: JSON.parse(loginuser),
      id: fileid,
      reason: "Request for Deviation",
      created_by: JSON.parse(loginuser),
      color: "#e03bdda6",
    };
    callApi("POST", "time_update.php", req)
      .then((res) => res.data)
      .then((response) => { });
  };

  returnPOFile = () => {
    this.setState({ returnPOValidation: true });
    const props: any = this.props;
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const { returnPOreason, returnPOValidation } = this.state;
    if (returnPOreason != "" && returnPOValidation) {
      this.setState({ isLoading: true });
      const obj = {
        file_id: props.match.params.id,
        return_by: userId,
        reason: returnPOreason,
      };
      callApi("POST", "return_to_po_file.php", obj)
        .then((res) => res.data)
        .then((response) => {
          if (response.statuscode == 200) {
            localStorage.removeItem("currentfileId");
            $("#returnPO").modal("hide");
            ToastsStore.success(response.message);
            this.setState({
              returnPOValidation: false,
              returnPOreason: "",
              isLoading: false,
            });
            this.props.history.push("/inprogress-file");
            // this.props.history.goBack();
            // this.verificationtime("hold");
          } else {
            ToastsStore.error(response.message);
          }
        });
    } else {
      ToastsStore.error("Please type reason");
    }
  };

  addUploadDocument = () => {
    let baseArray = cloneDeep(this.state.verificationbase);
    baseArray.push(this.documentFormat);
    this.setState({ verificationbase: baseArray });
  };

  handleDocumentDetailsChange = (value, index, key) => {
    const invalidDocuments = [
      "26",
      "27",
      "36",
      "35",
      "38",
      "103",
      "78",
      "5",
      "Online Encumbrance Certificate",
    ];
    if (key == "docNoYear") {
      const isValidInput = /^[0-9/-]*$/.test(value);

      if (!isValidInput) {
        console.error(
          "Invalid input. Please enter only numeric characters, slash, or hyphen."
        );
        return;
      }
      let baseArray = cloneDeep(this.state.verificationbase);
      baseArray[index] = {
        ...baseArray[index],
        [key]: value,
      };
      this.setState({ verificationbase: baseArray });
    } else {
      let baseArray = cloneDeep(this.state.verificationbase);
      if (key == "doc_type") {
        if (invalidDocuments.includes(value)) {
          baseArray[index] = {
            ...baseArray[index],
            docNoYear: "",
          };
          this.setState({ verificationbase: baseArray });
        }
      }

      baseArray[index] = {
        ...baseArray[index],
        [key]: value,
      };
      this.setState({ verificationbase: baseArray });
    }
  };
  // handleDocumentFilesChange1 = (value, index, key) => {
  //   let baseArray = cloneDeep(this.state.verificationbase);
  //   baseArray[index] = {
  //     ...baseArray[index],
  //     base: value.fileList[0].name,
  //     base_url: value.base64,
  //   };
  //   this.setState({ verificationbase: baseArray });
  // };

  handleDocumentFilesChange1 = async (value, index, parentDetails) => {
    const { isGlobalPdfCompress } = this.state;
    this.setState({ isbtnload: true });
    try {
      const fileObj = value.fileList[0];

      // Get base64 (some upload libraries provide directly, some require conversion)
      let base64 = fileObj.base64 || value.base64;

      // If not PDF → directly upload
      if (!fileObj?.type?.includes("pdf")) {
        return this.uploadAndSync(value, base64, index, null);
      }

      // If compression disabled → upload original
      if (
        !isGlobalPdfCompress ||
        parentDetails.isPdfCompress != "on" ||
        fileObj.alreadyCompressed
      ) {
        return this.uploadAndSync(value, base64, index, null);
      }

      // Get quality settings
      const {
        deeds,
        globalPdfCompressQuality,
        isSroEcPdfCompressQuality,
        isOnlineEcPdfCompressQuality,
      }: any = this.state;

      let quality =
        parentDetails.doc_type === "SRO Encumbrance Certificate"
          ? isSroEcPdfCompressQuality || globalPdfCompressQuality
          : parentDetails.doc_type === "Online Encumbrance Certificate"
            ? isOnlineEcPdfCompressQuality || globalPdfCompressQuality
            : deeds?.find((d: any) => d.id === parentDetails.doc_type)?.quality ||
            globalPdfCompressQuality;

      // Compress PDF
      const compressResponse = await compressPdf({
        base64: base64,
        quality,
      });

      // Prevent double compression
      fileObj.alreadyCompressed = true;

      // Upload compressed output
      this.uploadAndSync(
        value,
        compressResponse.compressedBase64,
        index,
        compressResponse
      );
    } catch (err) {
      console.error("Error in handleDocumentFilesChange1:", err);
      ToastsStore.error("File processing failed");
    }
  };

  uploadAndSync = (files, base64, index, compressResponse) => {
    // Update UI immediately
    const baseArray = cloneDeep(this.state.verificationbase);
    const fileObj = files.fileList[0];

    baseArray[index] = {
      ...baseArray[index],
      base: fileObj.name,
      base_url: base64,
      originalSize: compressResponse?.originalSize || "",
      compressedSize: compressResponse?.compressedSize || "",
    };

    this.setState({ verificationbase: baseArray, isbtnload: false });
  };

  deleteDocumentDetails = (index) => {
    const baseArray = cloneDeep(this.state.verificationbase);
    baseArray.splice(index, 1);
    this.setState({ verificationbase: baseArray });
  };
  deleteFile = (index) => {
    const baseArray = cloneDeep(this.state.verificationbase);
    baseArray[index] = {
      ...baseArray[index],
      details: {},
      base: "",
    };
    this.setState({ verificationbase: baseArray });
  };
  previewDoc = (modal) => {
    this.setState({ previewDoc: modal });
  };
  validateRequiredFileds = (e) => {
    if (this.state.verificationbase && this.state.verificationbase.length > 0) {
      this.uploadFiles();
    } else {
    }
  };
  closeuploadfile = () => {
    this.setState({ verificationbase: [] });
  };
  getCategories = () => {
    callApi("POST", "category.php")
      .then((res) => res.data)
      .then((response) => {
        this.setState({ categoriesList: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  uploadFiles = () => {
    const isValid = this.validateDocuments();
    let updatedRemainingTime: any = localStorage.getItem(
      "updatedRemainingTime"
    );
    let updatedtime = Math.round(updatedRemainingTime);
    if (!isValid) {
      // Show error message or handle validation error
      ToastsStore.error("Please fill in all fields for this document");
      return;
    } else {
      this.setState({ isbtnload: true });
      this.setState({ uploadbtn: true });
      let flag_status;
      if (this.state.filestatus == "7") {
        flag_status = 1;
      } else {
        flag_status = 0;
      }
      callApi("POST", "doc_file_upload.php", {
        id: this.props.match.params.id,
        uploadfile: this.state.verificationbase,
        flag_status: flag_status,
        type: "verification",
      })
        .then((res) => res)
        .then((response) => {
          const responseData = response.data;
          let doc_count =
            Number(this.state.verificationbase.length) +
            Number(this.state.doc_count);
          if (responseData.success === true) {
            let request = {
              file_id: this.props.match.params.id,
              doc_count: doc_count,
              balance_min: updatedtime,
            };
            callApi("POST", "file_time.php", request)
              .then((res) => res.data)
              .then((response) => {
                if (response.status == "200") {
                  if (this.countdownTimerRef) {
                    this.countdownTimerRef.clearInterval();
                  }
                  localStorage.removeItem("updatedRemainingTime");
                  window.location.reload();
                }
              });
            if (this.state.filestatus == "7") {
              this.timeUpdate(this.props.match.params.id, "query receive");
            } else {
              this.timeUpdate(this.props.match.params.id, "before query raise");
            }
            this.setState({ isbtnload: false });
            this.setState({ uploadbtn: false });
            this.setState({ verificationbase: [] });
            $("#upload-modal").modal("hide");
            const user: any = localStorage.getItem("user");
            const userId = user ? JSON.parse(user)["userId"] : "";
            const userName = user ? JSON.parse(user)["firstName"] : "";
            const notifyData = {
              fileId: this.props.match.params.id,
              title: `${this.props.match.params.id}Query Upload`,
              notifyType: "message",
              updatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
            };
            let user_id = userId;
            pushnotificationApi(notifyData, user_id);
            const branchManger: any = localStorage.getItem("branch_manager");
            const branch_Manager = JSON.parse(branchManger);
            const queryOfficer: any = localStorage.getItem("Query_officer");
            const query_ooficer = JSON.parse(queryOfficer);
            const Scan_officer: any = localStorage.getItem("scan_officer");
            const sacanofficer = JSON.parse(Scan_officer);
            const process_mennager: any =
              localStorage.getItem("process_manager");
            const processManager = JSON.parse(process_mennager);
            if (Array.isArray(branch_Manager) && branch_Manager.length > 0) {
              notifyToUser(
                "user",
                { ...notifyData, notifyType: "message" },
                branch_Manager
              );
              const branchManager = branch_Manager.join(",");
              let obj = {
                // notification_type:"queryupload",
                user_id: branchManager,
                ...notifyData,
              };
              callApi("POST", "pushnotification.php", obj)
                .then((res) => res.data)
                .then((response) => { })
                .catch((err) => {
                  console.log(err);
                });
            }
            if (Array.isArray(query_ooficer) && query_ooficer.length > 0) {
              notifyToUser(
                "user",
                { ...notifyData, notifyType: "message" },
                query_ooficer
              );
              const Queryofficer = query_ooficer.join(",");
              let obj = {
                // notification_type:"queryupload",
                user_id: Queryofficer,
                ...notifyData,
              };
              callApi("POST", "pushnotification.php", obj)
                .then((res) => res.data)
                .then((response) => { })
                .catch((err) => {
                  console.log(err);
                });
            }
            if (Array.isArray(sacanofficer) && sacanofficer.length > 0) {
              notifyToUser(
                "user",
                { ...notifyData, notifyType: "message" },
                sacanofficer
              );
              const ScanOfficer = sacanofficer.join(",");
              let obj = {
                // notification_type:"queryupload",
                user_id: ScanOfficer,
                ...notifyData,
              };
              callApi("POST", "pushnotification.php", obj)
                .then((res) => res.data)
                .then((response) => { })
                .catch((err) => {
                  console.log(err);
                });
            }
            if (Array.isArray(processManager) && processManager.length > 0) {
              notifyToUser(
                "user",
                { ...notifyData, notifyType: "message" },
                processManager
              );
              const ProcessManager = processManager.join(",");
              let obj = {
                // notification_type:"queryupload",
                user_id: ProcessManager,
                ...notifyData,
              };
              callApi("POST", "pushnotification.php", obj)
                .then((res) => res.data)
                .then((response) => { })
                .catch((err) => {
                  console.log(err);
                });
            }
            ToastsStore.success("File(s) Uploaded Successully");
          } else {
            this.setState({ uploadbtn: false });
            this.setState({ isbtnload: false });
            ToastsStore.success("File(s) Not Uploaded");
          }
        })
        .catch((err) => {
          this.setState({ isbtnload: false });
          this.setState({ uploadbtn: false });

          // this.setState({ verificationbase: [] });
        });
    }
  };

  validateDocuments = () => {
    let base: any = this.state.verificationbase;
    let isValid = true;
    const invalidDocuments = [
      "26",
      "27",
      "36",
      "35",
      "38",
      "103",
      "78",
      "5",
      "Online Encumbrance Certificate",
    ];
    for (let i = 0; i < base.length; i++) {
      const document = base[i];

      if (invalidDocuments.includes(document.doc_type)) {
        base[i].isValid = true;
      } else {
        if (
          document.type == "deed" ||
          document.type == "mother_doc" ||
          document.type == "title_deed" ||
          document.type == "ec_doc"
        ) {
          if (
            !document.docNoYear ||
            !document.doc_type ||
            !document.type ||
            !document.particular ||
            !document.base
          ) {
            isValid = false;
            base[i].isValid = false;
          } else {
            base[i].isValid = true;
          }
        } else if (
          document.type == "rev_rec_doc" ||
          document.type == "sale_agreement"
        ) {
          if (
            !document.doc_type ||
            !document.type ||
            !document.particular ||
            !document.base
          ) {
            isValid = false;
            base[i].isValid = false;
          } else {
            base[i].isValid = true;
          }
        } else {
          isValid = false;
          base[i].isValid = false;
        }
      }
    }
    return isValid;
  };
  timeUpdate = (fileid, type) => {
    const loginuser: any = localStorage.getItem("user1");
    let req;
    if (type == "query receive") {
      req = {
        query_received_by: JSON.parse(loginuser),
        id: fileid,
        reason: "Query Received",
        created_by: JSON.parse(loginuser),
        color: "#edada0",
      };
    } else if (type == "query raise") {
      req = {
        query_raised_by: JSON.parse(loginuser),
        id: fileid,
        reason: "Query Raised",
        created_by: JSON.parse(loginuser),
        color: "#afa5bd",
      };
    } else if (type == "before query raise") {
      req = {
        id: fileid,
        reason: "Scan File Upload",
        created_by: JSON.parse(loginuser),
        reason_status: 1,
      };
    } else {
      req = {
        // id: fileid,
        // reason: "File Out",
        // created_by: JSON.parse(loginuser)
      };
    }
    callApi("POST", "time_update.php", req)
      .then((res) => res.data)
      .then((response) => { });
  };
  handleCheck = () => {
    const { history, match } = this.props;
    const verifiedfile = "verification";
    localStorage.removeItem("finalapprovalprocesscheck");
    localStorage.setItem('verififinalapprove', "verififinalapprove");
    history.push({
      pathname: `/work-file-details/${match.params.id}`,
      state: { verifiedfile },
    });
  };

  render() {
    const { isOpen } = this.state;
    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["role_id"] : "";
    const { flowGraphData } = this.state;
    const {
      data,
      report,
      action,
      uploadFile,
      reason,
      verification,
      rotation,
      velocityEqualToMove,
      enableVelocity,
      highlights,
      isHightlightsLoaded,
      base,
      lastUploadedDocument,
      lastScrutinyDocument,
      isComplete,
      showTitle,
      docToPreview,
      newQueryList,
      queryQues,
      quesSubmitted,
      queryLoading,
    } = this.state;
    const iframeSource = lastUploadedDocument.pdf
      ? lastUploadedDocument.pdf
      : lastScrutinyDocument
        ? lastScrutinyDocument
        : "";
    const iframeSourcesoftware = this.state.overviewReport ?? "";
    const {
      isQuestionsExpanded,
      autoQuestionsList,
      manualQuestionsList,
      activeTab,
      currentAutoColumnNumber,
      currentManualColumnNumber,
    } = this.state;
    let currentQuestionsList =
      activeTab === "AutomaticView" ? autoQuestionsList : manualQuestionsList;
    let currentColumnNumber =
      activeTab === "AutomaticView"
        ? currentAutoColumnNumber
        : currentManualColumnNumber;
    const verification_officer: any = localStorage.getItem(
      "verification_office_id"
    );
    const userid1: any = localStorage.getItem("user1");
    const userid = JSON.parse(userid1);

    return (
      <div className="pcoded-content sop">
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />
        <div className="pcoded-inner-content">
          <div className="main-body">
            <div className="page-wrapper">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="row">
                      <div className="col-md-12 mt-2">
                        {verification_officer == userid &&
                          this.state.initialTimeInMinutes &&
                          this.state.initialTimeInMinutes > 0 && (
                            <CountdownTimer
                              initialTime={this.state.initialTimeInMinutes}
                              updatedTime={(time) =>
                                this.updatedRemainingTime(time)
                              }
                              ref={(ref) => (this.countdownTimerRef = ref)}
                            />
                          )}
                        {this.state.isOnLoading && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i className="fa fa-spinner fa-spin"></i>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <div className="d-flex">
                          {this.state.verify_officer != "" && (
                            <>
                              <h5 style={{ marginLeft: "1%" }}>
                                VO - {this.state.verify_officer}
                              </h5>
                            </>
                          )}
                          {this.state.dverify_officer != "" && (
                            <>
                              <h5 style={{ marginLeft: "1%" }}>|</h5>
                              <h5 style={{ marginLeft: "1%" }}>
                                DVO - {this.state.dverify_officer}
                              </h5>
                            </>
                          )}
                        </div>
                      </div>
                      <div
                        className="col-md-6 row"
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          alignItems: "center",
                        }}
                      >
                        {this.state.file_grade == "E" && (
                          <>
                            <span
                              className="badge badge-warning"
                              style={{ fontSize: "15px" }}
                            >
                              Emergent
                            </span>
                          </>
                        )}
                        <button
                          className="btn btn-warning float-right"
                          onClick={() => this.gotoFlowchart()}
                        >
                          Flow Chart
                        </button>
                        <button
                          className="btn btn-success float-right mr-5"
                          onClick={() => this.gotoWorkfile()}
                        >
                          Work File
                        </button>

                        {/* <div
                          className="menu-container float-right"
                          ref={this.menuRef}
                        >
                          <button
                            className="menu-icon mr-4"
                            onClick={this.toggleMenu}
                            style={{
                              background: "white",
                              color: "black",
                              border: "none",
                            }}
                          >
                            <PiDotsThreeCircleVerticalFill
                              style={{ height: "50", width: "40px" }}
                            />
                          </button>
                          {isOpen && (
                            <div className="menu-items">
                              <div
                                className="menu-item"
                                onClick={() => this.gotoFlowchart()}
                              >
                                Flow Chart
                              </div>
                              <div
                                className="menu-item"
                                onClick={() => this.gotoWorkfile()}
                              >
                                Work File
                              </div>
                            </div>
                          )}
                        </div> */}
                      </div>
                    </div>
                    <div className="card-header row">
                      <div className="col-md-5 row">
                        <h5
                          className="font-weight-bold text-uppercase"
                          style={{ alignSelf: "center" }}
                        >
                          Work File Verification list
                        </h5>
                        <div style={{ width: "50%" }}>
                          {this.state.allDocuments &&
                            this.state.allDocuments.length > 0 && (
                              <div style={{ minWidth: "40%" }}>
                                {this.state.allDocuments &&
                                  this.state.allDocuments.length > 0 &&
                                  this.state.allDocuments.map((opt: any) => {
                                    opt.label =
                                      "Document - " +
                                      opt.id +
                                      (opt.status == 1
                                        ? "- (Not Related)"
                                        : "");
                                    opt.value = opt.base_id;
                                  }) && (
                                    <Select
                                      options={this.state.allDocuments}
                                      name="selectedDoc"
                                      value={this.state.allDocuments.find(
                                        (o: any) =>
                                          o.value === this.state.selectedDoc
                                      )}
                                      onChange={(e) =>
                                        this.viewDocument(e.value)
                                      }
                                    />
                                  )}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="col-md-7">
                        {this.state.blockdownload == "false" ||
                          this.state.fileOpinionType != "1" ? (
                          <>
                            <button
                              className="btn btn-outline-dark"
                              onClick={() => this.actionHandle("download")}
                              data-toggle="modal"
                              data-target="#reason-modal"
                            >
                              Download Doc
                            </button>
                            <button
                              className="btn btn-outline-dark"
                              onClick={() => this.actionHandle("upload")}
                              data-toggle="modal"
                              data-target="#reason-modal"
                            >
                              Upload Doc
                            </button>
                          </>
                        ) : (
                          <>
                            {/* {(role_id === ADMIN_ROLE) ? (
                              <>
                                <button className="btn btn-outline-dark"
                                  onClick={() => this.actionHandle("download")}
                                  data-toggle="modal" data-target="#reason-modal">
                                  Download Doc
                                </button>
                                <button className="btn btn-outline-dark"
                                  onClick={() => this.actionHandle("upload")}
                                  data-toggle="modal" data-target="#reason-modal">
                                  Upload Doc
                                </button>
                              </>
                            ) : ""
                            } */}
                          </>
                        )}
                        {isComplete && (
                          <button
                            type="button"
                            className="btn btn-primary"
                            style={{ marginTop: "0px" }}
                            onClick={this.enableModalHandler}
                            disabled={
                              this.state.overviewReport == "" ||
                              this.state.verificationEOD == false ||
                              this.state.data.isVerified == false ||
                              this.state.isLoading
                            }
                          >
                            {this.state.isLoading ? (
                              <i className="fa fa-spinner fa-spin"></i>
                            ) : (
                              "Complete"
                            )}
                          </button>
                        )}

                        {!isComplete && (
                          <>
                            <button
                              onClick={this.completeModalHandler}
                              type="button"
                              className="btn btn-primary"
                              style={{ marginTop: "0px" }}
                              disabled={
                                this.state.overviewReport == "" ||
                                this.state.verificationEOD == false ||
                                this.state.data.isVerified == false ||
                                this.state.isLoading
                              }
                            >
                              {this.state.isLoading ? (
                                <i className="fa fa-spinner fa-spin"></i>
                              ) : (
                                "Complete"
                              )}
                            </button>
                          </>
                        )}
                        <button
                          className="btn btn-secondary float-right"
                          onClick={async () => {
                            await localStorage.removeItem("currentfileId");
                            // this.props.history.goBack()
                            this.props.history.push("/inprogress-file");
                          }}
                        >
                          Back
                        </button>
                        <button
                          className="btn btn-danger float-right"
                          data-toggle="modal"
                          data-target="#holdModal"
                        >
                          Hold
                        </button>
                        {/* <button
                          className="btn btn-info float-right"
                          data-toggle="modal"
                          data-target="#returnPO"
                        >
                          Return to PO
                        </button> */}
                        <button
                          className="btn btn-success float-right"
                          data-toggle="modal"
                          data-target="#upload-modal"
                          onClick={() => this.getCategories()}
                        >
                          Upload
                        </button>
                        <button
                          className="btn btn-warning float-right"
                          onClick={this.handleCheck}
                        >
                          Check
                        </button>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div>
                            <div className="container">
                              <ul
                                className="nav nav-tabs"
                                id="myTab"
                                role="tablist"
                              >
                                <li className="nav-item">
                                  <a
                                    className="nav-link active"
                                    id="old-view-tab"
                                    data-toggle="tab"
                                    href="#old-viewer"
                                    role="tab"
                                    aria-controls="home"
                                    aria-selected="true"
                                  >
                                    Old Viewer
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    id="new-view-tab"
                                    data-toggle="tab"
                                    href="#new-viewer"
                                    role="tab"
                                    aria-controls="profile"
                                    aria-selected="false"
                                    onClick={() =>
                                      this.setState({ docToPreview: true })
                                    }
                                  >
                                    New Viewer
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    id="new-view-tab"
                                    data-toggle="tab"
                                    href="#upload-view1"
                                    role="tab"
                                    aria-controls="profile"
                                    aria-selected="false"
                                  >
                                    Last Uploaded TIR
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className="nav-link"
                                    id="new-view-tab"
                                    data-toggle="tab"
                                    href="#software-view1"
                                    role="tab"
                                    aria-controls="profile"
                                    aria-selected="false"
                                  >
                                    Software Generated Copy
                                  </a>
                                </li>
                              </ul>

                              <div className="tab-content" id="tab-content">
                                <div
                                  className="tab-pane fade show active"
                                  id="old-viewer"
                                  role="tabpanel"
                                  aria-labelledby="old-viewer"
                                >
                                  <iframe
                                    src={this.document.base}
                                    width="100%"
                                    height={this.state.documentHeight}
                                  />

                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="new-viewer"
                                  role="tabpanel"
                                  aria-labelledby="new-viewer"
                                >
                                  <p style={{ color: "red" }}>
                                    NOTE: TO HIGHLIGHT [ ALT + RIGHT CLICK ON
                                    MOUSE AND DRAG ]
                                  </p>
                                  <br />
                                  <div
                                    className="App"
                                    style={{
                                      display: "flex",
                                      height: "calc(90vh - 110px)",
                                    }}
                                  >
                                    <TransformWrapper
                                      pan={{
                                        disabled: true,
                                        velocityEqualToMove,
                                        velocity: enableVelocity,
                                      }}
                                      wheel={{
                                        disabled: true,
                                      }}
                                    >
                                      {({
                                        zoomIn,
                                        zoomOut,
                                        resetTransform,
                                        ...rest
                                      }) => (
                                        <React.Fragment>
                                          <div className="tools">
                                            <Rotate90DegreesCcwIcon
                                              className="pdf-icon rotate-icon"
                                              onClick={this.rotate}
                                            />
                                            <ZoomInIcon
                                              className="pdf-icon"
                                              onClick={zoomIn}
                                            />
                                            <ZoomOutIcon
                                              className="pdf-icon"
                                              onClick={zoomOut}
                                            />
                                            <FullscreenExitIcon
                                              className="pdf-icon"
                                              onClick={resetTransform}
                                            />
                                            {base && isHightlightsLoaded && (
                                              <FullscreenIcon
                                                className="pdf-icon"
                                                onClick={() =>
                                                  this.setState({
                                                    docToPreview: true,
                                                  })
                                                }
                                              />
                                            )}
                                          </div>
                                          <TransformComponent>
                                            <div
                                              style={{
                                                height: "calc(90vh - 110px)",
                                                width: "45vw",
                                                position: "relative",
                                                transform: `rotate(${rotation}deg)`,
                                              }}
                                            >
                                              {base && !docToPreview && (
                                                <PdfHighlighter
                                                  url={base}
                                                  onHighlightsChange={
                                                    this.onHighlightsChange
                                                  }
                                                  highlights={highlights}
                                                />
                                              )}
                                            </div>
                                          </TransformComponent>
                                        </React.Fragment>
                                      )}
                                    </TransformWrapper>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="upload-view1"
                                  role="tabpanel"
                                  aria-labelledby="upload-view1"
                                >
                                  {iframeSource && (
                                    <iframe
                                      src={iframeSource}
                                      width="100%"
                                      height={this.state.documentHeight}
                                    />
                                  )}
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="software-view1"
                                  role="tabpanel"
                                  aria-labelledby="software-view1"
                                >
                                  <div className="iframe-container">

                                    {iframeSourcesoftware ? (
                                      <iframe
                                        src={iframeSourcesoftware}
                                        width="100%"
                                        height={this.state.documentHeight}
                                      />
                                    ) : (
                                      <div className="text-center">
                                        <h4>
                                          <span>
                                            Loading... {this.state.timer}{" "}
                                            seconds
                                          </span>
                                        </h4>
                                      </div>
                                    )}
                                    <div className="top-overlay"></div>
                                    <div className="bottom-overlay"></div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="container">
                            <ul
                              className="nav nav-tabs"
                              id="myTab"
                              role="tablist"
                            >
                              <li className="nav-item">
                                <a
                                  className="nav-link active"
                                  id="old-view-tab"
                                  data-toggle="tab"
                                  href="#verify-view"
                                  role="tab"
                                  aria-controls="home"
                                  aria-selected="true"
                                >
                                  Checklist
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  id="new-view-tab"
                                  data-toggle="tab"
                                  href="#upload-view"
                                  role="tab"
                                  aria-controls="profile"
                                  aria-selected="false"
                                >
                                  Last Uploaded TIR
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  id="new-view-tab"
                                  data-toggle="tab"
                                  href="#software-view"
                                  role="tab"
                                  aria-controls="profile"
                                  aria-selected="false"
                                >
                                  Software Generated Copy
                                </a>
                              </li>
                            </ul>
                            <div
                              className="tab-content"
                              id="tab-content"
                              style={{ padding: 0 }}
                            >
                              <div
                                className="tab-pane fade show active"
                                id="verify-view"
                                role="tabpanel"
                                aria-labelledby="verify-view"
                              >
                                <div
                                  style={{
                                    border: "1px solid #dee2e6",
                                    borderRadius: "8px",
                                    height: "675px",
                                  }}
                                >
                                  <div
                                    className="container verify-container"
                                    style={{ height: "675px", width: "100%", position: "relative" }}
                                  >
                                    {this.state.formDataLoading && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          right: 0,
                                          bottom: 0,
                                          backgroundColor: "rgba(255,255,255,0.85)",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          zIndex: 10,
                                          borderRadius: "8px",
                                        }}
                                      >
                                        <div className="text-center">
                                          <div
                                            className="spinner-border text-primary"
                                            role="status"
                                            style={{ width: "3rem", height: "3rem" }}
                                          >
                                            <span className="sr-only">Loading...</span>
                                          </div>
                                          <p className="mt-2 mb-0">Loading verification checklist...</p>
                                        </div>
                                      </div>
                                    )}
                                    <div
                                      style={{
                                        overflow: "auto",
                                        height: "550px",
                                      }}
                                    >
                                      <GeneralVerification
                                        data={data.generalVerification}
                                        handleGeneralVerifyChange={
                                          this.handleGeneralVerifyChange
                                        }
                                      />
                                      <SurveyNoVerification
                                        data={data?.surveyNoVerification}
                                        handleSurveyNoVerify={
                                          this.handleSurveyNoVerifyChange
                                        }
                                      />
                                      <Deed
                                        data={data.deed}
                                        handleDeedChange={this.handleDeedChange}
                                      />
                                      <LegalHerisVerification
                                        data={data.legalHeirsVerify}
                                        handleLegalHerisChange={
                                          this.handleLegalHerisChange
                                        }
                                      />
                                      <ECVerification
                                        data={data.ecVerify}
                                        handleEcVerifyChange={
                                          this.handleEcVerifyChange
                                        }
                                      />
                                      <MissingLOD
                                        data={data.missingLOD}
                                        handleLodChange={this.handleLodChange}
                                      />
                                      <Verification
                                        data={data.verification}
                                        handleVerifyChange={
                                          this.handleVerifyChange
                                        }
                                      />
                                      <CourtDocVerify
                                        data={data.courtDocVerification}
                                        handleCourtVerifyChange={
                                          this.handleCourtVerifyChange
                                        }
                                      />
                                      <Hsdpatta
                                        data={data.HsdpattasVerify}
                                        handleHsdpattaChange={
                                          this.handleHsdpattaChange
                                        }
                                      />
                                      <Nathampatta
                                        data={data.nathamPattaverify}
                                        handleNathampattaChange={
                                          this.handleNathampattaChange
                                        }
                                      />
                                      <Flow
                                        data={data.flow}
                                        handleFlowChange={this.handleFlowChange}
                                      />
                                      <Propertytax
                                        data={data.propertytax}
                                        handlePropertytaxChange={
                                          this.handlePropertytaxChange
                                        }
                                      />
                                      <EBreceipt
                                        data={data.EBreceiptData}
                                        handleEBreceiptChange={
                                          this.handleEBreceiptChange
                                        }
                                      />
                                      <OriginalDocVerify
                                        data={data.originalDocVerification}
                                        handleOriginalDocVerifyChange={
                                          this.handleOriginalDocVerifyChange
                                        }
                                      />
                                      <div className="collapse-section">
                                        <Card>
                                          <Card.Header>
                                            <h5>
                                              <b>
                                                * Remarks (if Any)/Any Error
                                                Found?
                                              </b>
                                            </h5>
                                          </Card.Header>
                                          <Card.Body>
                                            <div className="row">
                                              <div className="form-group col-md-12">
                                                <label
                                                  className="label"
                                                  style={{ padding: 0 }}
                                                >
                                                  *Have you found any error/ is
                                                  there any remark for the file?
                                                </label>
                                              </div>
                                            </div>
                                            <div className="row">
                                              {/* <div className='col-md-3'>
                                                                                <Form.Check
                                                                                    inline
                                                                                    label="Nill"
                                                                                    name="spellcorrect"
                                                                                    type="radio"
                                                                                />
                                                                            </div> */}
                                              {/* <div className='form-group col-md-1'>
                                                                                    <Form.Check
                                                                                        inline
                                                                                        name="spellcorrect"
                                                                                        type="radio"
                                                                                    />
                                                                                </div> */}
                                              <div className="form-group col-md-12">
                                                <textarea
                                                  placeholder="Enter Remarks"
                                                  className="form-control"
                                                  name="remarks"
                                                  value={data.remarks}
                                                  onChange={(e) => {
                                                    this.setState({
                                                      data: {
                                                        ...data,
                                                        [e.target.name]:
                                                          e.target.value,
                                                      },
                                                    });
                                                  }}
                                                  ref={this.remarksRef}
                                                />
                                                {/* <input
                                                                                                        className="form-control"
                                                                                                        name="remarks"
                                                                                                        ref={this.remarksRef}
                                                                                                        type="text"
                                                                                                        placeholder='Enter Remarks'
                                                                                                        value={data.remarks}
                                                                                                        onChange={(e) => {
                                                                                                            this.setState({
                                                                                                                data: {
                                                                                                                    ...data,
                                                                                                                    [e.target.name]: e.target.value
                                                                                                                }
                                                                                                            })
                                                                                                        }}
                                                                                                    /> */}
                                              </div>
                                            </div>
                                          </Card.Body>
                                        </Card>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        marginTop: "32px",
                                      }}
                                    >
                                      <Form.Check
                                        inline
                                        label="I've Double-Checked Everything All of The Data Is Correct And Reliable"
                                        name="isVerified"
                                        type="checkbox"
                                        checked={data.isVerified}
                                        onChange={this.handleChange}
                                      />
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-success"
                                          onClick={this.saveVerification}
                                        >
                                          Save
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-primary"
                                          disabled={!data.isVerified}
                                          onClick={this.verifyModalHandler}
                                        >
                                          Verification EOD
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="upload-view"
                                role="tabpanel"
                                aria-labelledby="upload-view"
                              >
                                {iframeSource && (
                                  <iframe
                                    src={iframeSource}
                                    width="100%"
                                    // height={this.state.documentHeight}
                                    height="672px"
                                  />
                                )}
                              </div>
                              <div
                                className="tab-pane fade"
                                id="software-view"
                                role="tabpanel"
                                aria-labelledby="software-view"
                              >
                                <div className="iframe-container">

                                  {iframeSourcesoftware ? (
                                    <iframe
                                      src={iframeSourcesoftware}
                                      width="100%"
                                      // height={this.state.documentHeight}
                                      height="672px"
                                    />
                                  ) : (
                                    <div className="text-center">
                                      <h4>
                                        <span>
                                          Loading... {this.state.timer} seconds
                                        </span>
                                      </h4>
                                    </div>
                                  )}
                                  <div className="top-overlay"></div>
                                  <div className="bottom-overlay"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <VerificationEOD
              verify={verification}
              setVerify={this.setVerify}
              saveUploadData={this.verificationEODHandler}
            // completeEnable={this.completeEnable}
            />
            <div
              className={`modal ${this.state.docToPreview ? "open" : ""}`}
              id="new-preview-document"
              role="dialog"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-xl"
                role="document"
                style={{ maxWidth: "90%" }}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close cursor-pointer"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => this.setState({ docToPreview: false })}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div
                    className="modal-body"
                    style={{ transform: `rotate(${this.state.rotation}deg)` }}
                  >
                    {this.state.base && this.state.isHightlightsLoaded && (
                      <PdfHighlighter
                        url={this.state.base}
                        onHighlightsChange={this.onHighlightsChange}
                        highlights={this.state.highlights}
                        rotation={this.state.rotation}
                        isPopup
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal" id="reason-modal">
              <div className="modal-dialog ">
                <div className="modal-content">
                  <div className="modal-header">
                    {action === "download" ? (
                      <h5 className="modal-title">Reason For Download</h5>
                    ) : (
                      <h5 className="modal-title">Reason For Upload</h5>
                    )}
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                  </div>
                  <div className="modal-body">
                    <div>
                      {action === "download" ? (
                        <label>Enter Reason*</label>
                      ) : (
                        <React.Fragment>
                          <label>Enter Updated Informations*</label>
                          <ReactFileReader
                            fileTypes={[".doc", ".docx"]}
                            base64={true}
                            // multipleFiles={true}
                            handleFiles={(e) => this.uploadFile(e)}
                          >
                            <button
                              className="ml2 btn btn-success btnupload"
                            // disabled={this.state.isFlowChartUploading}
                            >
                              {/* {this.state.isFlowChartUploading ? (
                                                                <i className="fa fa-spinner fa-spin"></i>
                                                            ) : <i className="icon feather icon-upload" />} */}
                              Select File
                            </button>
                          </ReactFileReader>
                          <span>{uploadFile.fileList[0].name}</span>
                        </React.Fragment>
                      )}
                      <textarea
                        className="form-control mt-10"
                        name="reason"
                        value={reason}
                        onChange={this.handleReasonChange}
                      ></textarea>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn " data-dismiss="modal">
                      Cancel
                    </button>
                    {action === "download" ? (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.validateReason}
                      >
                        Download
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.validateReason}
                      >
                        Upload
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal hide fade in"
              id="processComplete"
              data-backdrop="static"
              data-keyboard="false"
            >
              <div className="modal-dialog ">
                <div
                  className="modal-content"
                  style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                >
                  <div className="modal-body">
                    <h5 style={{ textAlign: "center" }}>
                      {" "}
                      Thanks For Complete Your Verification File:
                      {this.props.match.params.id}
                    </h5>
                  </div>
                  <div className="modal-footer">
                    {showTitle ? null : (
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => this.close()}
                        // onClick={this.disableModalHandler}
                        style={{
                          width: "50%",
                          fontSize: "17px",
                          margin: "auto",
                        }}
                      >
                        {" "}
                        Ok
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal" id="complete-process">
              <div className="modal-dialog ">
                <div className="modal-content">
                  <div className="modal-body">
                    <h3>Without upload document you can't complete the file</h3>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-dismiss="modal"
                    // onClick={this.disableModalHandler}
                    >
                      {" "}
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal"
              id="file_not_complete_modal"
              role="dialog"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-body">
                    <h5
                      style={{ textAlign: "left" }}
                      dangerouslySetInnerHTML={this.state.fileNotCompleteMsg}
                    />
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-dismiss="modal"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal" id="hint-modal">
              <div className="modal-dialog modal-xl">
                <div className="modal-content">
                  <div className="modal-body">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4>Hint About Files</h4>
                    <div
                      className="model-xl"
                      style={{
                        height: "660px",
                        position: "relative",
                        overflow: "auto",
                      }}
                    >
                      <div className="card-body">
                        <div className="latest-update-box">
                          {this.state.hints &&
                            this.state.hints.length > 0 &&
                            this.state.hints.map((hint: any, index: number) => (
                              <div
                                className={
                                  index === 0
                                    ? "row p-t-20 p-b-20"
                                    : "row p-b-20"
                                }
                              >
                                <div className="col-auto text-right update-meta">
                                  <i className="bi bi-chevron-double-right"></i>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-chevron-double-right"
                                    viewBox="0 0 16 16"
                                    color="blue"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"
                                    />
                                  </svg>
                                </div>
                                <div className="col p-l-5">
                                  <h6 className="m-0">
                                    {hint.created_by}{" "}
                                    <span style={{ fontSize: "12px" }}>
                                      {hint.created_date
                                        ? "(" +
                                        moment(hint.created_date).format(
                                          "DD/MM/YYYY hh:mm:ss"
                                        ) +
                                        ")"
                                        : ""}
                                    </span>
                                  </h6>
                                  <p
                                    className="m-b-0"
                                    style={{ wordBreak: "break-word" }}
                                  >
                                    {hint.hints}
                                    {/* <a href="#!" className="text-c-blue"> More</a> */}
                                  </p>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-dismiss="modal"
                      // onClick={this.disableModalHandler}
                      style={{ float: "right" }}
                    >
                      {" "}
                      close
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal" id="open-graphData1-modal">
              <div className="modal-dialog modal-xl ">
                <div className="modal-content">
                  <div className="modal-body">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="row">
                      <div className="col-md-7">
                        <h4>Flow Chart</h4>
                        <div
                          className="model-xl"
                          style={{
                            height: "655px",
                            position: "relative",
                            overflow: "auto",
                          }}
                        >
                          <div className="card-body">
                            {/* <div id="open-graphData1-modal" ref="manualPaperRef" /> */}
                            <>
                              <Flowchart
                                fileId={this.props.match.params.id}
                                isflowGraphDataupdated={
                                  this.state.isflowGraphDataupdated
                                }
                              />
                            </>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-5">
                          <h4>Questions</h4>
                          <div
                            className="model-xl"
                            style={{ height: "655px", position: "relative" }}
                          >
                            <div className="card-body">
                              <div className="row">
                                <div className="col-md-5"></div>
                                <div className="col-md-2"></div>
                                {/* <div className="col-md-2">
                                                                    <button
                                                                        className="btn btn-sm btn-success"
                                                                        id="hideOnDownload"
                                                                        onClick={() => this.saveFlowChart("questions")}
                                                                    >
                                                                        Save
                                                                    </button>
                                                                </div> */}
                              </div>

                              <div style={{ marginBottom: "3%" }}>
                                {this.state.manualQuestionsList.map(
                                  (question: any, questIndex) => {
                                    return (
                                      <div
                                        key={questIndex}
                                        className="row"
                                        style={{
                                          alignItems: "center",
                                          textAlign: "center",
                                          marginTop: "1.5%",
                                        }}
                                      >
                                        <div
                                          className="col-md-2"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {question && question.name
                                            ? question.name
                                            : ""}
                                        </div>
                                        <div className="col-md-5">
                                          <textarea
                                            name="qustion"
                                            onChange={(e) =>
                                              this.handleQuestion(
                                                e.target.value,
                                                questIndex
                                              )
                                            }
                                            className="form-control"
                                            value={question.value}
                                            placeholder="Question"
                                            style={{ width: "360px" }}
                                          />
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-dismiss="modal"
                      // onClick={this.disableModalHandler}
                      style={{ float: "right" }}
                    >
                      {" "}
                      close
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="holdModal"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div
                className="modal-dialog"
                role="document"
                style={{
                  maxWidth: "800px",
                  maxHeight: "660px",
                  overflow: "scroll",
                }}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5>
                      Are you sure you want to hold {this.props.match.params.id}
                      ?
                    </h5>
                  </div>
                  {this.state.holdVal && (
                    <>
                      <div className="modal-body">
                        <p style={{ textAlign: "center", color: "black" }}>
                          Please Select Type and Provide Reason to Hold the File
                        </p>

                        {/* --- Added Select Field --- */}
                        <div
                          className="form-group"
                          style={{
                            width: "98%",
                            margin: "auto",
                            marginBottom: "10px",
                          }}
                        >
                          <select
                            className="form-control"
                            name="holdType"
                            value={this.state.holdType}
                            onChange={this.onchange}
                          >
                            <option value="">-- Select Hold Type --</option>
                            <option value="Hold">Hold</option>
                            <option value="Hold Query Raised">
                              Hold Query Raised
                            </option>
                          </select>
                          {isEmpty(this.state.holdType) ? (
                            <p
                              style={{
                                color: "red",
                                textAlign: "center",
                                fontSize: "16px",
                                marginTop: "5px",
                              }}
                            >
                              Please select a hold type
                            </p>
                          ) : null}
                        </div>

                        {!isEmpty(this.state.holdType) &&
                          this.state.holdType == "Hold Query Raised" &&
                          newQueryList && (
                            <>
                              <div
                                className="raise-query-style"
                                style={{ marginTop: "4%", flex: 1 }}
                              >
                                <QueryAdd
                                  addnewQueryList={newQueryList}
                                  handleChange={this.handleChangequery}
                                  handleDetailsChange={this.handleDetailsChange}
                                  removeReply={this.removeReply}
                                  newaddrequery={this.newaddrequery}
                                  queryreason={this.state.reasons}
                                />
                              </div>
                            </>
                          )}

                        {/* --- Existing Reason Field --- */}
                        <div
                          className="form-group"
                          style={{ width: "98%", margin: "auto" }}
                        >
                          <textarea
                            className="form-control"
                            placeholder="Type Your Reason"
                            name="holdreason"
                            value={this.state.holdreason}
                            onChange={this.onchange}
                          />
                          {isEmpty(this.state.holdreason) ? (
                            <p
                              style={{
                                color: "red",
                                textAlign: "center",
                                fontSize: "16px",
                              }}
                            >
                              Please type your reason
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </>
                  )}
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => this.handleHoldFile()}
                    >
                      {this.state.isLoading ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : (
                        "Yes"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal" id="send-mail">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title">Send Mail</h4>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                  </div>
                  <div className="modal-body">
                    {!quesSubmitted && (
                      <div className="query-question">
                        <div className="row">
                          {queryQues.map((ques: any, index) => (
                            <div className="col-md-6" key={index}>
                              <div className="question">
                                <p>{ques.query_question}</p>
                                <div className="row">
                                  <div className="col-md-3">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="radio"
                                        className=""
                                        name={`answer-${index}`}
                                        checked={ques.answer}
                                        onChange={() =>
                                          this.handleAnswerChange(index, true)
                                        }
                                      />
                                      <label className="">Yes</label>
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="radio"
                                        className=""
                                        name={`answer-${index}`}
                                        checked={!ques.answer}
                                        onChange={() =>
                                          this.handleAnswerChange(index, false)
                                        }
                                      />
                                      <label className="">No</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-info"
                            onClick={this.saveQueryQuestion}
                          >
                            <span>Submit</span>
                          </button>
                        </div>
                      </div>
                    )}
                    {quesSubmitted && (
                      <div className="row">
                        <div className="col-md-6">
                          <label>To:</label>
                          <div className="form-group">
                            {this.state.office_users &&
                              this.state.office_users.length ? (
                              this.state.office_users.map(
                                (user: any, index) => {
                                  return (
                                    <div
                                      className="custom-control custom-checkbox"
                                      key={index}
                                    >
                                      <input
                                        type="checkbox"
                                        className=""
                                        onChange={(e) =>
                                          this.selectUser(e, user)
                                        }
                                        defaultChecked
                                      />
                                      <label className="">
                                        {user.name + " - " + user.email}
                                      </label>
                                    </div>
                                  );
                                }
                              )
                            ) : (
                              <button
                                onClick={this.addItem}
                                className="btn btn-primary m-b-20"
                              >
                                + Add User
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label>Cc:</label>
                          <div className="form-group">
                            {this.state.office_users &&
                              this.state.office_users.length ? (
                              this.state.office_users.map(
                                (user: any, index) => {
                                  return (
                                    <div
                                      className="custom-control custom-checkbox"
                                      key={index}
                                    >
                                      <input
                                        type="checkbox"
                                        className=""
                                        onChange={(e) =>
                                          this.selectCcUser(e, user)
                                        }
                                        defaultChecked
                                      />
                                      <label className="">
                                        {user.name + " - " + user.email}
                                      </label>
                                    </div>
                                  );
                                }
                              )
                            ) : (
                              <button
                                onClick={this.addItem}
                                className="btn btn-primary m-b-20"
                              >
                                + Add User
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {quesSubmitted && (
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-danger"
                        data-dismiss="modal"
                        onClick={() => {
                          this.setState({ quesSubmitted: false });
                        }}
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        className="btn btn-info"
                        // data-dismiss="modal"
                        disabled={queryLoading}
                        onClick={this.saveQuery}
                      >
                        {queryLoading ? (
                          <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          <span>Send</span>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="returnPO"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5>
                      Are you sure you want to send this file{" "}
                      {this.props.match.params.id} back to the PO ?
                    </h5>
                  </div>
                  {this.state.returnPOValidation && (
                    <>
                      <div className="modal-body">
                        <p style={{ textAlign: "center", color: "black" }}>
                          Please Type a Reason To send The File back to the PO
                        </p>
                        <div
                          className="form-group"
                          style={{ width: "98%", margin: "auto" }}
                        >
                          <textarea
                            className="form-control"
                            placeholder="Type Your Reason"
                            name="returnPOreason"
                            onChange={this.onchange}
                          />
                          {isEmpty(this.state.returnPOreason) ? (
                            <p
                              style={{
                                color: "red",
                                textAlign: "center",
                                fontSize: "16px",
                              }}
                            >
                              Please type your reason{" "}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </>
                  )}
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => this.returnPOFile()}
                    >
                      {this.state.isLoading ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : (
                        "Yes"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* //upload modal. */}
            <div
              className="modal fade bd-example-modal-lg"
              id="upload-modal"
              tabIndex={-1}
              role="dialog"
              aria-hidden="true"
            >
              <div
                className="modal-dialog"
                style={{ maxWidth: "1400px" }}
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Upload File</h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="text-right">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm upload-document-button"
                        onClick={() => this.addUploadDocument()}
                      >
                        Add Document +
                      </button>
                    </div>
                    {this.state.verificationbase.length > 0 &&
                      this.state.verificationbase.map((document, index) => (
                        <DashUploadDocument
                          baseDetails={document}
                          handleDocumentDetailsChange={
                            this.handleDocumentDetailsChange
                          }
                          handleDocumentFilesChange={
                            this.handleDocumentFilesChange1
                          }
                          deleteDocumentDetails={this.deleteDocumentDetails}
                          deleteFile={this.deleteFile}
                          deedList={this.state.deeds}
                          previewDoc={this.previewDoc}
                          categoriesList={this.state.categoriesList}
                          index={index}
                          newfile={this.state.isNewFile}
                          state={this.state}
                          path="filedashboard"
                          isbtnload={this.state.uploadbtn}
                        />
                      ))}
                    <div className="modal-footer" style={{ border: "none" }}>
                      <div style={{ margin: "auto" }}>
                        {this.state.verificationbase.length > 0 && (
                          <>
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                              onClick={this.closeuploadfile}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              style={{ margin: "auto" }}
                              // data-dismiss="modal"
                              disabled={this.state.uploadbtn == true}
                              onClick={(e) => this.validateRequiredFileds(e)}
                            >
                              {this.state.isbtnload && (
                                <i className="fa fa-spinner fa-spin"></i>
                              )}
                              Confirm
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`modal ${this.state.previewDoc ? "open" : ""}`}
              id="preview-document"
              role="dialog"
              aria-hidden={this.state.previewDoc === ""}
              {...(this.state.previewDoc === "" && { inert: "" })}
            >
              <div
                className="modal-dialog modal-lg"
                role="document"
                style={{ maxWidth: "1400px" }}
              >
                <div className="modal-content" style={{ height: "90vh" }}>
                  <div className="modal-header">
                    <h5 className="modal-title">Document Preview</h5>
                    <button
                      type="button"
                      className="close cursor-pointer"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => this.setState({ previewDoc: "" })}
                    >
                      <span aria-hidden={this.state.previewDoc === ""}>
                        &times;
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <iframe
                      width="100%"
                      height="100%"
                      src={this.state.previewDoc}
                    ></iframe>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                      onClick={() => this.setState({ previewDoc: "" })}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  handleQuestion(value: string, questIndex: number): void {
    throw new Error("Method not implemented.");
  }
}

export default VerificationList;
